/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Paytrie API v2
 * OpenAPI spec version: 2.0.0
 */
import { customFetch } from './mutator'
export type ErrorErrorsItem = {
  field?: string
  message: string
}

export interface Error {
  success: false
  errors: ErrorErrorsItem[]
}

export type ApproveMagicLinkResponseTokenType =
  (typeof ApproveMagicLinkResponseTokenType)[keyof typeof ApproveMagicLinkResponseTokenType]

export const ApproveMagicLinkResponseTokenType = {
  Bearer: 'Bearer',
} as const

export interface ApproveMagicLinkResponse {
  accessToken: string
  tokenType: ApproveMagicLinkResponseTokenType
  expiresIn: number
}

export interface MagicLinkDetails {
  email: string
  requestIp: string
  /** @nullable */
  requestLocation: string | null
  requestedAt: string
  expiresAt: string
}

export type AuthTokenPendingStatus =
  (typeof AuthTokenPendingStatus)[keyof typeof AuthTokenPendingStatus]

export const AuthTokenPendingStatus = {
  pending: 'pending',
} as const

export interface AuthTokenPending {
  status: AuthTokenPendingStatus
}

export type AuthTokenVerifiedStatus =
  (typeof AuthTokenVerifiedStatus)[keyof typeof AuthTokenVerifiedStatus]

export const AuthTokenVerifiedStatus = {
  verified: 'verified',
} as const

export type AuthTokenVerifiedTokenType =
  (typeof AuthTokenVerifiedTokenType)[keyof typeof AuthTokenVerifiedTokenType]

export const AuthTokenVerifiedTokenType = {
  Bearer: 'Bearer',
} as const

export interface AuthTokenVerified {
  status: AuthTokenVerifiedStatus
  accessToken: string
  tokenType: AuthTokenVerifiedTokenType
  expiresIn: number
}

export type AuthTokenDeniedStatus =
  (typeof AuthTokenDeniedStatus)[keyof typeof AuthTokenDeniedStatus]

export const AuthTokenDeniedStatus = {
  denied: 'denied',
} as const

export interface AuthTokenDenied {
  status: AuthTokenDeniedStatus
}

export type AuthTokenResponse =
  | AuthTokenPending
  | AuthTokenVerified
  | AuthTokenDenied

export type LoginCodeTokenResponseTokenType =
  (typeof LoginCodeTokenResponseTokenType)[keyof typeof LoginCodeTokenResponseTokenType]

export const LoginCodeTokenResponseTokenType = {
  Bearer: 'Bearer',
} as const

export interface LoginCodeTokenResponse {
  accessToken: string
  tokenType: LoginCodeTokenResponseTokenType
  expiresIn: number
}

export type UserLinkLinkStatus =
  (typeof UserLinkLinkStatus)[keyof typeof UserLinkLinkStatus]

export const UserLinkLinkStatus = {
  linked: 'linked',
} as const

export interface UserLink {
  userId: string
  linkStatus: UserLinkLinkStatus
  linkedAt: string
}

export type RecordEventRequestPayload = { [key: string]: unknown }

export interface RecordEventRequest {
  /**
   * Canonical name of the event. Use snake_case verb_object names (e.g. `wallet_connected`, `quote_failed`).
   * @pattern ^[a-z][a-z0-9_-]{0,127}$
   */
  eventName: string
  /**
   * Originating surface for the event (e.g. `widget`, `mobile`, `gmt`). Used to distinguish events from different clients sharing the same integrator API key.
   * @minLength 1
   * @maxLength 64
   */
  source?: string
  /** Client-reported event timestamp (ISO 8601). The server records its own received_at timestamp regardless. */
  occurredAt?: string
  payload?: RecordEventRequestPayload
}

export interface FeatureFlag {
  key: string
  enabled: boolean
}

export type FeatureFlags = FeatureFlag[]

export interface LimitRange {
  minimum: number
  maximum: number
}

export type LimitsLeftSideCurrency = {
  CAD: LimitRange
  CADC: LimitRange
  USDC: LimitRange
}

export interface Limits {
  leftSideCurrency: LimitsLeftSideCurrency
}

export interface MaintenanceWindow {
  id: number
  title: string
  /** Plain-language impact, safe to show to end users. */
  description: string
  startsAt: string
  /**
   * When the window is expected to end. `null` for unplanned maintenance whose end is not yet known.
   * @nullable
   */
  endsAt: string | null
}

/**
 * The integrator this deployment is registered to, or null for a first-party deployment.
 * @nullable
 */
export type WidgetConfigIntegrator = {
  appId: string
  /** @nullable */
  name: string | null
} | null

export interface WidgetConfig {
  /**
   * The integrator this deployment is registered to, or null for a first-party deployment.
   * @nullable
   */
  integrator: WidgetConfigIntegrator
  /**
   * Where to send the user once onboarding is complete. Null means stay on the deployment.
   * @nullable
   */
  completionRedirectUrl: string | null
}

export type OtcRequestStatus =
  (typeof OtcRequestStatus)[keyof typeof OtcRequestStatus]

export const OtcRequestStatus = {
  'awaiting-fiat': 'awaiting-fiat',
  processing: 'processing',
  submitted: 'submitted',
  'awaiting-crypto': 'awaiting-crypto',
  complete: 'complete',
  cancelled: 'cancelled',
} as const

export interface OtcRequest {
  id: string
  userId: string
  leftSideLabel: string
  leftSideValue: number
  rightSideLabel: string
  wallet: string
  /** @nullable */
  purpose: string | null
  /** @nullable */
  sourceOfFunds: string | null
  /**
   * Bank account the payout settles to. Null when no bank payout was requested.
   * @nullable
   */
  bankDetailsId: number | null
  /**
   * Set once the request is cancelled; null while it is open.
   * @nullable
   */
  cancelledAt: string | null
  /** Transactions settled from this request. Non-empty once the OTC desk has processed it. */
  transactionIds: string[]
  /**
   * Most recently linked transaction ID, when ops has created a transaction from this request.
   * @nullable
   */
  transactionId: string | null
  status: OtcRequestStatus
  createdAt: string
  updatedAt: string
}

export interface OtcRequestList {
  items: OtcRequest[]
  /** Total OTC requests for the user */
  total: number
  limit: number
  offset: number
}

/**
 * Currency sold.
 */
export type CreateOtcRequestLeftSideLabel =
  (typeof CreateOtcRequestLeftSideLabel)[keyof typeof CreateOtcRequestLeftSideLabel]

export const CreateOtcRequestLeftSideLabel = {
  CAD: 'CAD',
  'USDC-ARB': 'USDC-ARB',
  'USDC-AVAX': 'USDC-AVAX',
  'USDC-BASE': 'USDC-BASE',
  'USDC-BSC': 'USDC-BSC',
  'USDC-CELO': 'USDC-CELO',
  'USDC-ETH': 'USDC-ETH',
  'USDC-FTM': 'USDC-FTM',
  'USDC-GNO': 'USDC-GNO',
  'USDC-LIN': 'USDC-LIN',
  'USDC-OP': 'USDC-OP',
  'USDC-POLY': 'USDC-POLY',
  'USDC-SOL': 'USDC-SOL',
  'USDC-SX': 'USDC-SX',
  'CADC-ARB': 'CADC-ARB',
  'CADC-BASE': 'CADC-BASE',
  'CADC-ETH': 'CADC-ETH',
  'CADC-LIN': 'CADC-LIN',
  'CADC-POLY': 'CADC-POLY',
  'CADC-SOL': 'CADC-SOL',
} as const

/**
 * Currency received.
 */
export type CreateOtcRequestRightSideLabel =
  (typeof CreateOtcRequestRightSideLabel)[keyof typeof CreateOtcRequestRightSideLabel]

export const CreateOtcRequestRightSideLabel = {
  CAD: 'CAD',
  'USDC-ARB': 'USDC-ARB',
  'USDC-AVAX': 'USDC-AVAX',
  'USDC-BASE': 'USDC-BASE',
  'USDC-BSC': 'USDC-BSC',
  'USDC-CELO': 'USDC-CELO',
  'USDC-ETH': 'USDC-ETH',
  'USDC-FTM': 'USDC-FTM',
  'USDC-GNO': 'USDC-GNO',
  'USDC-LIN': 'USDC-LIN',
  'USDC-OP': 'USDC-OP',
  'USDC-POLY': 'USDC-POLY',
  'USDC-SOL': 'USDC-SOL',
  'USDC-SX': 'USDC-SX',
  'CADC-ARB': 'CADC-ARB',
  'CADC-BASE': 'CADC-BASE',
  'CADC-ETH': 'CADC-ETH',
  'CADC-LIN': 'CADC-LIN',
  'CADC-POLY': 'CADC-POLY',
  'CADC-SOL': 'CADC-SOL',
} as const

/**
 * Why the user is making the trade (canonical code).
 */
export type CreateOtcRequestPurpose =
  (typeof CreateOtcRequestPurpose)[keyof typeof CreateOtcRequestPurpose]

export const CreateOtcRequestPurpose = {
  investment: 'investment',
  business_operations: 'business_operations',
  personal_savings: 'personal_savings',
  goods_and_services: 'goods_and_services',
  family_support: 'family_support',
} as const

/**
 * Where the funds being traded originated (canonical code).
 */
export type CreateOtcRequestSourceOfFunds =
  (typeof CreateOtcRequestSourceOfFunds)[keyof typeof CreateOtcRequestSourceOfFunds]

export const CreateOtcRequestSourceOfFunds = {
  employment_income: 'employment_income',
  business_revenue: 'business_revenue',
  savings: 'savings',
  investments: 'investments',
  sale_of_assets: 'sale_of_assets',
  inheritance: 'inheritance',
} as const

/**
 * Bank account to pay out to. Reused if the user already has a saved account with these exact details, otherwise saved against the user. Mutually exclusive with `bankDetailsId`.
 */
export interface BankDetails {
  /**
   * Name on the bank account receiving the payout.
   * @minLength 1
   * @maxLength 255
   */
  accountHolderName: string
  /** @pattern ^\d{3}$ */
  institutionNumber: string
  /** @pattern ^\d{5}$ */
  transitNumber: string
  /** @pattern ^\d{7,12}$ */
  accountNumber: string
  /**
   * Optional label the user gives this bank account.
   * @minLength 1
   * @maxLength 255
   */
  nickname?: string
}

export interface CreateOtcRequest {
  /** Currency sold. */
  leftSideLabel: CreateOtcRequestLeftSideLabel
  /**
   * Amount sold. OTC has a minimum of 10000, denominated in the `leftSideLabel` currency.
   * @minimum 10000
   */
  leftSideValue: number
  /** Currency received. */
  rightSideLabel: CreateOtcRequestRightSideLabel
  /**
   * Wallet the crypto side of the trade settles against (EVM or Solana, depending on the chosen network).
   * @minLength 1
   */
  wallet: string
  /** Why the user is making the trade (canonical code). */
  purpose: CreateOtcRequestPurpose
  /** Where the funds being traded originated (canonical code). */
  sourceOfFunds: CreateOtcRequestSourceOfFunds
  bankDetails?: BankDetails
  /**
   * Id of a bank account already saved against the user. Mutually exclusive with `bankDetails`.
   * @exclusiveMinimum 0
   */
  bankDetailsId?: number
  /** Iframe vendor app code, accepted only with the api key. Does not affect source classification (still `widget`); the vendor integrator itself is not stored on the OTC request. */
  vendorId?: string
}

export interface OtcWireBank {
  name: string
  address: string
  swiftCode: string
}

export interface OtcWireRecipient {
  beneficiaryName: string
  beneficiaryAddress: string
  institutionNumber: string
  transitNumber: string
  accountNumber: string
}

export interface OtcWireInstructions {
  bank: OtcWireBank
  recipient: OtcWireRecipient
}

export interface QuoteBreakdown {
  /** The fee on this quote. */
  paytrieFee: number
  /** The part of paytrieFee you cover when fee sponsorship is enabled for your key. The user pays paytrieFee minus sponsoredFee minus referralDiscount. */
  sponsoredFee: number
  /** The part of paytrieFee covered by the user's referral credit. Zero unless useReferral is set. */
  referralDiscount: number
  /** Fee rate as a fraction of the pay-side amount; 0.006 is 0.6%. */
  feeRate: number
  /** Minimum fee in the pay-side currency. */
  minFee: number
  gasFee: number
  gasPrice: number
  usdToCad: number
}

export interface Quote {
  quoteId: number
  leftSideLabel: string
  leftSideValue: number
  rightSideLabel: string
  rightSideValue: number
  breakdown: QuoteBreakdown
  timestamp: string
}

/**
 * @nullable
 */
export type TransactionStatus =
  | (typeof TransactionStatus)[keyof typeof TransactionStatus]
  | null

export const TransactionStatus = {
  cancelled: 'cancelled',
  complete: 'complete',
  expired: 'expired',
  'expired-contact-support': 'expired-contact-support',
  'awaiting-fiat': 'awaiting-fiat',
  'processing-fiat': 'processing-fiat',
  'finalizing-fiat': 'finalizing-fiat',
  'sending-crypto': 'sending-crypto',
  'sending-fiat': 'sending-fiat',
  'awaiting-crypto': 'awaiting-crypto',
  refunded: 'refunded',
  replaced: 'replaced',
} as const

export interface Transaction {
  id: string
  /** @nullable */
  date: string | null
  coin: string
  leftSideLabel: string
  leftSideValue: number
  rightSideLabel: string
  rightSideValue: number
  /** @nullable */
  status: TransactionStatus
  wallet: string
  /** @nullable */
  paymentType: string | null
  /** @nullable */
  paymentId: string | null
  /** @nullable */
  rmtId: string | null
  /**
   * Paytrie-owned wallet to send funds to; only populated for SELL transactions.
   * @nullable
   */
  depositAddress: string | null
}

export interface TransactionList {
  items: Transaction[]
  /** Total transactions for the user */
  total: number
  limit: number
  offset: number
}

/**
 * Currency paid in.
 */
export type CreateTransactionRequestLeftSideLabel =
  (typeof CreateTransactionRequestLeftSideLabel)[keyof typeof CreateTransactionRequestLeftSideLabel]

export const CreateTransactionRequestLeftSideLabel = {
  CAD: 'CAD',
  'USDC-ARB': 'USDC-ARB',
  'USDC-AVAX': 'USDC-AVAX',
  'USDC-BASE': 'USDC-BASE',
  'USDC-BSC': 'USDC-BSC',
  'USDC-CELO': 'USDC-CELO',
  'USDC-ETH': 'USDC-ETH',
  'USDC-FTM': 'USDC-FTM',
  'USDC-GNO': 'USDC-GNO',
  'USDC-LIN': 'USDC-LIN',
  'USDC-OP': 'USDC-OP',
  'USDC-POLY': 'USDC-POLY',
  'USDC-SOL': 'USDC-SOL',
  'USDC-SX': 'USDC-SX',
  'CADC-ARB': 'CADC-ARB',
  'CADC-BASE': 'CADC-BASE',
  'CADC-ETH': 'CADC-ETH',
  'CADC-LIN': 'CADC-LIN',
  'CADC-POLY': 'CADC-POLY',
  'CADC-SOL': 'CADC-SOL',
} as const

/**
 * Currency received.
 */
export type CreateTransactionRequestRightSideLabel =
  (typeof CreateTransactionRequestRightSideLabel)[keyof typeof CreateTransactionRequestRightSideLabel]

export const CreateTransactionRequestRightSideLabel = {
  CAD: 'CAD',
  'USDC-ARB': 'USDC-ARB',
  'USDC-AVAX': 'USDC-AVAX',
  'USDC-BASE': 'USDC-BASE',
  'USDC-BSC': 'USDC-BSC',
  'USDC-CELO': 'USDC-CELO',
  'USDC-ETH': 'USDC-ETH',
  'USDC-FTM': 'USDC-FTM',
  'USDC-GNO': 'USDC-GNO',
  'USDC-LIN': 'USDC-LIN',
  'USDC-OP': 'USDC-OP',
  'USDC-POLY': 'USDC-POLY',
  'USDC-SOL': 'USDC-SOL',
  'USDC-SX': 'USDC-SX',
  'CADC-ARB': 'CADC-ARB',
  'CADC-BASE': 'CADC-BASE',
  'CADC-ETH': 'CADC-ETH',
  'CADC-LIN': 'CADC-LIN',
  'CADC-POLY': 'CADC-POLY',
  'CADC-SOL': 'CADC-SOL',
} as const

export interface CreateTransactionRequest {
  /** Currency paid in. */
  leftSideLabel: CreateTransactionRequestLeftSideLabel
  /**
   * Amount paid in.
   * @exclusiveMinimum 0
   */
  leftSideValue: number
  /** Currency received. */
  rightSideLabel: CreateTransactionRequestRightSideLabel
  /**
   * Destination wallet address (EVM or Solana, depending on the chosen network).
   * @minLength 1
   */
  wallet: string
  /**
   * Optional quote ID returned by /v2/quotes. When provided and still fresh (within ~10 minutes), the transaction is priced against that exact quote. If the quote is expired or no longer in our records, the latest available quote is used instead — the transaction still proceeds, but the rate may differ from what was originally displayed. Refresh the quote before submitting if more than ~10 minutes have elapsed. Omit to always use the latest quote.
   * @exclusiveMinimum 0
   */
  quoteId?: number
  /** Free-form integrator-side identifier echoed on webhooks. */
  externalSessionId?: string
  /** Iframe vendor app code. When the request is made with the api key, the transaction is re-attributed to the vendor integrator resolved by this id. */
  vendorId?: string
  /** When true, applies the user’s referral discount and decrements their credit. */
  useReferral?: boolean
}

export type UserSummaryAccessibleByItem =
  (typeof UserSummaryAccessibleByItem)[keyof typeof UserSummaryAccessibleByItem]

export const UserSummaryAccessibleByItem = {
  jwt: 'jwt',
  apiKey: 'apiKey',
} as const

export interface UserSummary {
  id: string
  /** How your integration can act on this user right now. Your API key is required either way; this reports whether an access token is needed alongside it. "jwt" means you must also send an access token the user grants you, obtained via POST /auth/login-codes. "apiKey" means your API key on its own is enough. */
  accessibleBy: UserSummaryAccessibleByItem[]
}

export type UserList = UserSummary[]

export type UserAccessibleByItem =
  (typeof UserAccessibleByItem)[keyof typeof UserAccessibleByItem]

export const UserAccessibleByItem = {
  jwt: 'jwt',
  apiKey: 'apiKey',
} as const

/**
 * @nullable
 */
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus] | null

export const UserStatus = {
  initial: 'initial',
  active: 'active',
  verified: 'verified',
  rejected: 'rejected',
  inactive: 'inactive',
  upload: 'upload',
  'in-review': 'in-review',
} as const

export interface User {
  id: string
  /** How your integration can act on this user right now. Your API key is required either way; this reports whether an access token is needed alongside it. "jwt" means you must also send an access token the user grants you, obtained via POST /auth/login-codes. "apiKey" means your API key on its own is enough. */
  accessibleBy: UserAccessibleByItem[]
  email: string
  /** @nullable */
  firstName: string | null
  /** @nullable */
  lastName: string | null
  /** @nullable */
  dob: string | null
  /** @nullable */
  phone: string | null
  /** @nullable */
  addressLine1: string | null
  /** @nullable */
  addressLine2: string | null
  /** @nullable */
  city: string | null
  /** @nullable */
  province: string | null
  /** @nullable */
  postalCode: string | null
  /** @nullable */
  country: string | null
  /** @nullable */
  occupation: string | null
  /**
   * True if the user is a politically exposed person, false otherwise.
   * @nullable
   */
  pep: boolean | null
  /**
   * True if the user is a third party determination, false otherwise.
   * @nullable
   */
  tpd: boolean | null
  /** @nullable */
  status: UserStatus
  /** @nullable */
  createdAt: string | null
}

export type CurrentUser = User & {
  /** Referral credits the user can spend on their own transactions. */
  referralCreditBalance: number
  /** @nullable */
  referralCode: string | null
  /**
   * The user's Interac e-Transfer security answer.
   * @nullable
   */
  interacAnswer: string | null
}

export type CorporationStatus =
  (typeof CorporationStatus)[keyof typeof CorporationStatus]

export const CorporationStatus = {
  draft: 'draft',
  'in-review': 'in-review',
  verified: 'verified',
} as const

export type CorporationAddressCountry =
  (typeof CorporationAddressCountry)[keyof typeof CorporationAddressCountry]

export const CorporationAddressCountry = {
  CA: 'CA',
  US: 'US',
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AN: 'AN',
  AO: 'AO',
  AQ: 'AQ',
  AR: 'AR',
  AS: 'AS',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CS: 'CS',
  CU: 'CU',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FM: 'FM',
  FO: 'FO',
  FR: 'FR',
  FX: 'FX',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GU: 'GU',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MH: 'MH',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MP: 'MP',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PR: 'PR',
  PS: 'PS',
  PT: 'PT',
  PW: 'PW',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SY: 'SY',
  SZ: 'SZ',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW',
  ZZ: 'ZZ',
} as const

/**
 * @nullable
 */
export type CorporationAddress = {
  /** @minLength 1 */
  addressLine1: string
  /** @nullable */
  addressLine2: string | null
  /** @minLength 1 */
  city: string
  /** @minLength 1 */
  province: string
  /** @minLength 1 */
  postalCode: string
  country: CorporationAddressCountry
} | null

export interface CorporationPerson {
  /** @minLength 1 */
  firstName: string
  /** @minLength 1 */
  lastName: string
  email: string
  /** @minLength 1 */
  occupation: string
  dateOfBirth: string
}

export type CorporationPersonResponse = CorporationPerson & {
  lastName?: string
}

/**
 * @nullable
 */
export type CorporationAuthorizedUser = {
  /** @minLength 1 */
  firstName: string
  /** @minLength 1 */
  lastName: string
  /** @minLength 1 */
  occupation: string
  dateOfBirth: string
  address: CorporationAddress | null
} | null

export interface Corporation {
  id: string
  status: CorporationStatus
  /**
   * The corporation's own user, created when the enrollment is verified and separate from the applicant's user. Quote and transact as this user once `status` is `verified`.
   * @nullable
   */
  corporationUserId: string | null
  corporationName: string
  corporationNumber: string
  corporationEmail: string
  /** @nullable */
  phone: string | null
  address: CorporationAddress | null
  /** @nullable */
  businessNature: string | null
  /** @nullable */
  purpose: string | null
  /** @nullable */
  sourceOfFunds: string | null
  /** @nullable */
  dateOfIncorporation: string | null
  /** @nullable */
  msbRegistered: boolean | null
  /** @nullable */
  isPep: boolean | null
  /** @nullable */
  tpd: boolean | null
  directors: CorporationPersonResponse[]
  /** @nullable */
  hasBeneficialOwners: boolean | null
  beneficialOwners: CorporationPersonResponse[]
  authorizedUser: CorporationAuthorizedUser | null
  documentsSubmitted: boolean
  createdAt: string
}

export type CreateCorporationRequestPurpose =
  (typeof CreateCorporationRequestPurpose)[keyof typeof CreateCorporationRequestPurpose]

export const CreateCorporationRequestPurpose = {
  payments: 'payments',
  payroll: 'payroll',
  treasury_management: 'treasury_management',
  trading_investments: 'trading_investments',
  merchant_transactions: 'merchant_transactions',
  defi_transactions: 'defi_transactions',
} as const

export type CreateCorporationRequestSourceOfFunds =
  (typeof CreateCorporationRequestSourceOfFunds)[keyof typeof CreateCorporationRequestSourceOfFunds]

export const CreateCorporationRequestSourceOfFunds = {
  business_revenue: 'business_revenue',
  investments_treasury: 'investments_treasury',
  loans_financing: 'loans_financing',
  grants: 'grants',
} as const

export interface CreateCorporationRequest {
  /** @minLength 1 */
  corporationName: string
  /** @minLength 1 */
  corporationNumber: string
  corporationEmail: string
  /** @minLength 1 */
  phone?: string
  address?: CorporationAddress | null
  /** @minLength 1 */
  businessNature?: string
  purpose?: CreateCorporationRequestPurpose
  sourceOfFunds?: CreateCorporationRequestSourceOfFunds
  dateOfIncorporation?: string
  msbRegistered?: boolean
  /** Self-attestation on whether any individual associated with the corporation, or their direct relatives, is a politically exposed person or the head of an international organization. Must be false — such corporations cannot be onboarded via the API. */
  isPep?: false
  /** Self-attestation on whether the corporation acts at the instruction of another person or entity. Must be false — such corporations cannot be onboarded via the API. */
  tpd?: false
  /** @minItems 1 */
  directors?: CorporationPerson[]
  /** True if any individual owns 25% or more of the corporation. */
  hasBeneficialOwners?: boolean
  beneficialOwners?: CorporationPerson[]
  authorizedUser?: CorporationAuthorizedUser | null
}

export type UpdateCorporationRequestPurpose =
  (typeof UpdateCorporationRequestPurpose)[keyof typeof UpdateCorporationRequestPurpose]

export const UpdateCorporationRequestPurpose = {
  payments: 'payments',
  payroll: 'payroll',
  treasury_management: 'treasury_management',
  trading_investments: 'trading_investments',
  merchant_transactions: 'merchant_transactions',
  defi_transactions: 'defi_transactions',
} as const

export type UpdateCorporationRequestSourceOfFunds =
  (typeof UpdateCorporationRequestSourceOfFunds)[keyof typeof UpdateCorporationRequestSourceOfFunds]

export const UpdateCorporationRequestSourceOfFunds = {
  business_revenue: 'business_revenue',
  investments_treasury: 'investments_treasury',
  loans_financing: 'loans_financing',
  grants: 'grants',
} as const

export interface UpdateCorporationRequest {
  /** @minLength 1 */
  corporationName?: string
  /** @minLength 1 */
  corporationNumber?: string
  corporationEmail?: string
  /** @minLength 1 */
  phone?: string
  address?: CorporationAddress | null
  /** @minLength 1 */
  businessNature?: string
  purpose?: UpdateCorporationRequestPurpose
  sourceOfFunds?: UpdateCorporationRequestSourceOfFunds
  dateOfIncorporation?: string
  msbRegistered?: boolean
  /** Self-attestation on whether any individual associated with the corporation, or their direct relatives, is a politically exposed person or the head of an international organization. Must be false — such corporations cannot be onboarded via the API. */
  isPep?: false
  /** Self-attestation on whether the corporation acts at the instruction of another person or entity. Must be false — such corporations cannot be onboarded via the API. */
  tpd?: false
  /** @minItems 1 */
  directors?: CorporationPerson[]
  /** True if any individual owns 25% or more of the corporation. */
  hasBeneficialOwners?: boolean
  beneficialOwners?: CorporationPerson[]
  authorizedUser?: CorporationAuthorizedUser | null
}

/**
 * Where the corporation was incorporated
 */
export type SubmitCorporationDocumentsRequestIncorporationJurisdiction =
  (typeof SubmitCorporationDocumentsRequestIncorporationJurisdiction)[keyof typeof SubmitCorporationDocumentsRequestIncorporationJurisdiction]

export const SubmitCorporationDocumentsRequestIncorporationJurisdiction = {
  federal: 'federal',
  alberta: 'alberta',
  british_columbia: 'british_columbia',
  manitoba: 'manitoba',
  new_brunswick: 'new_brunswick',
  newfoundland: 'newfoundland',
  nova_scotia: 'nova_scotia',
  ontario: 'ontario',
  pei: 'pei',
  quebec: 'quebec',
  saskatchewan: 'saskatchewan',
  nwt: 'nwt',
  nunavut: 'nunavut',
  yukon: 'yukon',
  non_canadian: 'non_canadian',
} as const

export interface SubmitCorporationDocumentsRequest {
  /**
   * Object names returned by the upload-urls request, once each file has been PUT to its signed URL.
   * @minItems 1
   * @maxItems 5
   * @items.minLength 1
   */
  objectNames: string[]
  /** Where the corporation was incorporated */
  incorporationJurisdiction: SubmitCorporationDocumentsRequestIncorporationJurisdiction
}

export type CorporationDocumentUploadUrlsUploadsItemRequiredHeaders = {
  [key: string]: string
}

export type CorporationDocumentUploadUrlsUploadsItem = {
  objectName: string
  uploadUrl: string
  requiredHeaders: CorporationDocumentUploadUrlsUploadsItemRequiredHeaders
  expiresAt: string
}

export interface CorporationDocumentUploadUrls {
  uploads: CorporationDocumentUploadUrlsUploadsItem[]
}

export interface AddCorporationAdditionalDocumentsRequest {
  /**
   * Object names returned by the upload-urls request, once each file has been PUT to its signed URL.
   * @minItems 1
   * @maxItems 5
   * @items.minLength 1
   */
  objectNames: string[]
}

export interface KycUrl {
  url: string
  expiresAt: string
}

/**
 * `pending` needs action from the user, `processing` is under review by Paytrie, `satisfied` needs nothing.
 */
export type UserRequirementDetailStatus =
  (typeof UserRequirementDetailStatus)[keyof typeof UserRequirementDetailStatus]

export const UserRequirementDetailStatus = {
  pending: 'pending',
  processing: 'processing',
  satisfied: 'satisfied',
} as const

/**
 * Why the requirement is in its current state, when there is more to say than the status alone.
 */
export type UserRequirementDetailReason =
  (typeof UserRequirementDetailReason)[keyof typeof UserRequirementDetailReason]

export const UserRequirementDetailReason = {
  documentUploadRequired: 'documentUploadRequired',
  manualReview: 'manualReview',
  verificationFailed: 'verificationFailed',
} as const

export interface UserRequirementDetail {
  /** `pending` needs action from the user, `processing` is under review by Paytrie, `satisfied` needs nothing. */
  status: UserRequirementDetailStatus
  /** Outstanding fields as dot-paths into the PATCH /users/{userId} body, so they can be submitted back as-is (e.g. `olderUserInfo.sourceOfFunds`). Empty when the requirement is not field-driven (e.g. `kyc`) or already satisfied. */
  requiredFields: string[]
  /** Why the requirement is in its current state, when there is more to say than the status alone. */
  reason?: UserRequirementDetailReason
}

/**
 * Every requirement keyed by name, with what is outstanding for each. This is the authoritative view — prefer it over the arrays below.
 */
export interface UserRequirementDetails {
  emailVerification: UserRequirementDetail
  phoneVerification: UserRequirementDetail
  disclosure: UserRequirementDetail
  personalInfo: UserRequirementDetail
  address: UserRequirementDetail
  occupation: UserRequirementDetail
  additionalInfo: UserRequirementDetail
  kyc: UserRequirementDetail
  kycRefresh: UserRequirementDetail
}

export type UserRequirementKey =
  (typeof UserRequirementKey)[keyof typeof UserRequirementKey]

export const UserRequirementKey = {
  emailVerification: 'emailVerification',
  phoneVerification: 'phoneVerification',
  disclosure: 'disclosure',
  personalInfo: 'personalInfo',
  address: 'address',
  occupation: 'occupation',
  additionalInfo: 'additionalInfo',
  kyc: 'kyc',
  kycRefresh: 'kycRefresh',
} as const

export interface UserRequirements {
  requirements: UserRequirementDetails
  /** Deprecated: read `requirements` instead. Requirements the user still needs to act on. */
  pending: UserRequirementKey[]
  /** Deprecated: read `requirements` instead. Requirements Paytrie is reviewing. */
  processing: UserRequirementKey[]
  /** Deprecated: read `requirements` instead. Requirements that need no action. */
  satisfied: UserRequirementKey[]
}

/**
 * @nullable
 */
export type UserSummaryWithStatusStatus =
  | (typeof UserSummaryWithStatusStatus)[keyof typeof UserSummaryWithStatusStatus]
  | null

export const UserSummaryWithStatusStatus = {
  initial: 'initial',
  active: 'active',
  verified: 'verified',
  rejected: 'rejected',
  inactive: 'inactive',
  upload: 'upload',
  'in-review': 'in-review',
} as const

export type UserSummaryWithStatus = UserSummary & {
  /** @nullable */
  status: UserSummaryWithStatusStatus
}

export interface BankAccount {
  id: number
  /** @nullable */
  nickname: string | null
  /** @nullable */
  bankName: string | null
  accountLast4: string
}

export interface BankAccountList {
  items: BankAccount[]
}

export interface KycDocumentsFinalized {
  finalizedObjects: string[]
}

export type KycUploadUrlsUploadsItemRequiredHeaders = { [key: string]: string }

export type KycUploadUrlsUploadsItem = {
  objectName: string
  uploadUrl: string
  requiredHeaders: KycUploadUrlsUploadsItemRequiredHeaders
  expiresAt: string
}

export interface KycUploadUrls {
  uploads: KycUploadUrlsUploadsItem[]
}

export interface WebhookConfiguration {
  url: string
  createdAt: string
  updatedAt: string
}

export type UpsertWebhookConfigurationResult = WebhookConfiguration & {
  /** Returned only on the very first PUT for an integrator that does not yet have a signing secret. On subsequent PUTs this field is omitted. Use POST /v2/webhook-configurations/signing-secret/rotate to rotate later. */
  signingSecret?: string
}

export interface WebhookTestResult {
  eventId: string
  deliveredStatusCode: number
  deliveredStatusText: string
}

export interface WebhookSigningSecret {
  signingSecret: string
}

/**
 * Which Paytrie frontend initiated the sign-in. Determines which domain the magic link in the email points to. Defaults to "widget" when omitted.
 */
export type RequestMagicLinkBodyClient =
  (typeof RequestMagicLinkBodyClient)[keyof typeof RequestMagicLinkBodyClient]

export const RequestMagicLinkBodyClient = {
  widget: 'widget',
  gmt: 'gmt',
} as const

export type RequestMagicLinkBody = {
  email: string
  sessionId: string
  /** Which Paytrie frontend initiated the sign-in. Determines which domain the magic link in the email points to. Defaults to "widget" when omitted. */
  client?: RequestMagicLinkBodyClient
  /**
   * Referral code to attribute to the user when the account is created on-demand. Ignored for existing users.
   * @minLength 1
   */
  referral?: string
  /**
   * Vendor / partner identifier (the integrator's app id). A new account is created under it; when the link is approved, the user is linked to that integrator. Honoured only for Paytrie's own api key.
   * @minLength 1
   */
  vendor?: string
}

export type DenyMagicLinkParams = {
  email: string
}

export type GetMagicLinkParams = {
  email: string
}

export type GetMagicLink200 = {
  success: true
  data: MagicLinkDetails
}

export type ApproveMagicLinkBody = {
  email: string
  /** Optional client-generated UUID for this tab. If supplied, the approver session row and JWT both carry this id, allowing pre-/post-login analytics events to stitch together. If omitted, the server mints one. */
  sessionId?: string
}

export type ApproveMagicLink200 = {
  success: true
  data: ApproveMagicLinkResponse
}

export type PollAuthTokenBody = {
  sessionId: string
}

export type PollAuthToken200 = {
  success: true
  data: AuthTokenResponse
}

export type SendLoginCodeBody = {
  email: string
}

export type VerifyLoginCodeBody = {
  email: string
  /** @pattern ^\d{4}$ */
  code: string
}

export type VerifyLoginCode200 = {
  success: true
  data: LoginCodeTokenResponse
}

export type RequestUserLinkBody = {
  email: string
}

export type VerifyUserLinkBody = {
  email: string
  /** The code Paytrie emailed to the user, as they supplied it. */
  code: string
}

export type VerifyUserLink200 = {
  success: true
  data: UserLink
}

export type GetFeatureFlagsParams = {
  /**
   * Comma-separated list of feature flag names to check the status of.
   * @minLength 1
   */
  flags: string
}

export type GetFeatureFlags200 = {
  success: true
  data: FeatureFlags
}

export type GetLimits200 = {
  success: true
  data: Limits
}

export type ListMaintenanceWindowsParams = {
  /**
   * Only return windows that end after this time, or have no end yet. Defaults to 30 days ago; at most 90 days ago.
   */
  endsAfter?: string
}

export type ListMaintenanceWindows200 = {
  success: true
  data: MaintenanceWindow[]
}

export type GetWidgetConfig200 = {
  success: true
  data: WidgetConfig
}

export type ListOtcRequestsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number
  /**
   * @minimum 0
   * @nullable
   */
  offset?: number | null
}

export type ListOtcRequests200 = {
  success: true
  data: OtcRequestList
}

export type CreateOtcRequest201 = {
  success: true
  data: OtcRequest
}

export type GetOtcWireInstructions200 = {
  success: true
  data: OtcWireInstructions
}

export type GetOtcRequest200 = {
  success: true
  data: OtcRequest
}

export type GetQuotesParams = {
  leftSideLabel?: GetQuotesLeftSideLabel
  leftSideValue?: number
  rightSideLabel?: GetQuotesRightSideLabel
  rightSideValue?: number
  /**
   * Apply the user's referral credit. Requires a user token.
   */
  useReferral?: boolean
  /**
   * Price as this vendor. Honoured with the Paytrie key or when it is your own app id; otherwise ignored.
   */
  vendorId?: string
}

export type GetQuotesLeftSideLabel =
  (typeof GetQuotesLeftSideLabel)[keyof typeof GetQuotesLeftSideLabel]

export const GetQuotesLeftSideLabel = {
  CAD: 'CAD',
  USD: 'USD',
  'USDC-ARB': 'USDC-ARB',
  'USDC-AVAX': 'USDC-AVAX',
  'USDC-BASE': 'USDC-BASE',
  'USDC-BSC': 'USDC-BSC',
  'USDC-CELO': 'USDC-CELO',
  'USDC-ETH': 'USDC-ETH',
  'USDC-FTM': 'USDC-FTM',
  'USDC-GNO': 'USDC-GNO',
  'USDC-LIN': 'USDC-LIN',
  'USDC-OP': 'USDC-OP',
  'USDC-POLY': 'USDC-POLY',
  'USDC-SOL': 'USDC-SOL',
  'USDC-SX': 'USDC-SX',
  'CADC-ARB': 'CADC-ARB',
  'CADC-BASE': 'CADC-BASE',
  'CADC-ETH': 'CADC-ETH',
  'CADC-LIN': 'CADC-LIN',
  'CADC-POLY': 'CADC-POLY',
  'CADC-SOL': 'CADC-SOL',
} as const

export type GetQuotesRightSideLabel =
  (typeof GetQuotesRightSideLabel)[keyof typeof GetQuotesRightSideLabel]

export const GetQuotesRightSideLabel = {
  CAD: 'CAD',
  USD: 'USD',
  'USDC-ARB': 'USDC-ARB',
  'USDC-AVAX': 'USDC-AVAX',
  'USDC-BASE': 'USDC-BASE',
  'USDC-BSC': 'USDC-BSC',
  'USDC-CELO': 'USDC-CELO',
  'USDC-ETH': 'USDC-ETH',
  'USDC-FTM': 'USDC-FTM',
  'USDC-GNO': 'USDC-GNO',
  'USDC-LIN': 'USDC-LIN',
  'USDC-OP': 'USDC-OP',
  'USDC-POLY': 'USDC-POLY',
  'USDC-SOL': 'USDC-SOL',
  'USDC-SX': 'USDC-SX',
  'CADC-ARB': 'CADC-ARB',
  'CADC-BASE': 'CADC-BASE',
  'CADC-ETH': 'CADC-ETH',
  'CADC-LIN': 'CADC-LIN',
  'CADC-POLY': 'CADC-POLY',
  'CADC-SOL': 'CADC-SOL',
} as const

export type GetQuotes200 = {
  success: true
  data: Quote
}

export type ListTransactionsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number
  /**
   * @minimum 0
   * @nullable
   */
  offset?: number | null
}

export type ListTransactions200 = {
  success: true
  data: TransactionList
}

export type CreateTransaction201 = {
  success: true
  data: Transaction
}

export type GetTransaction200 = {
  success: true
  data: Transaction
}

export type CancelTransaction200 = {
  success: true
  data: Transaction
}

export type ListUsersParams = {
  email: string
}

export type ListUsers200 = {
  success: true
  data: UserList
}

export type CreateUserBodyProvince =
  (typeof CreateUserBodyProvince)[keyof typeof CreateUserBodyProvince]

export const CreateUserBodyProvince = {
  ab: 'ab',
  bc: 'bc',
  mb: 'mb',
  nb: 'nb',
  nl: 'nl',
  ns: 'ns',
  nt: 'nt',
  nu: 'nu',
  on: 'on',
  pe: 'pe',
  qc: 'qc',
  sk: 'sk',
  yt: 'yt',
} as const

export type CreateUserBody = {
  email: string
  /** @minLength 1 */
  firstName: string
  /** @minLength 1 */
  lastName: string
  dob: string
  /** @pattern ^\d{10}$ */
  phone: string
  /** @minLength 1 */
  addressLine1: string
  addressLine2?: string
  /** @minLength 1 */
  city: string
  province: CreateUserBodyProvince
  /** @pattern ^[ABCEGHJ-NPRSTVXYabceghj-nprstvxy]\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z][ -]?\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z]\d$ */
  postalCode: string
  /** @minLength 1 */
  occupation: string
  /** Self-attestation on whether the user is a politically exposed person. Must be false — politically exposed persons cannot be signed up via the API. */
  pep: false
  /** Self-attestation on whether the user is a third party determination. Must be false — users acting on behalf of a third party cannot be signed up via the API. */
  tpd: false
}

export type CreateUser201 = {
  success: true
  data: User
}

export type GetCurrentUser200 = {
  success: true
  data: CurrentUser
}

export type UpdateCurrentUserBodyCurrentFlow =
  (typeof UpdateCurrentUserBodyCurrentFlow)[keyof typeof UpdateCurrentUserBodyCurrentFlow]

export const UpdateCurrentUserBodyCurrentFlow = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  VERIFY_PHONE: 'VERIFY_PHONE',
  DISCLOSURE: 'DISCLOSURE',
  PERSONAL_INFO: 'PERSONAL_INFO',
  OCCUPATION: 'OCCUPATION',
  ADDITIONAL_INFO: 'ADDITIONAL_INFO',
  ADDITIONAL_INFO_PAGE2: 'ADDITIONAL_INFO_PAGE2',
  FRAUD_WARNING_FOLLOW_UP: 'FRAUD_WARNING_FOLLOW_UP',
} as const

export type UpdateCurrentUserBodyProvince =
  (typeof UpdateCurrentUserBodyProvince)[keyof typeof UpdateCurrentUserBodyProvince]

export const UpdateCurrentUserBodyProvince = {
  ab: 'ab',
  bc: 'bc',
  mb: 'mb',
  nb: 'nb',
  nl: 'nl',
  ns: 'ns',
  nt: 'nt',
  nu: 'nu',
  on: 'on',
  pe: 'pe',
  qc: 'qc',
  sk: 'sk',
  yt: 'yt',
} as const

/**
 * Channel where the user started onboarding (e.g. `gmt`, `paytrie-web`). Defaults to `paytrie-web` when omitted at user creation.
 */
export type UpdateCurrentUserBodyOnboardingSource =
  (typeof UpdateCurrentUserBodyOnboardingSource)[keyof typeof UpdateCurrentUserBodyOnboardingSource]

export const UpdateCurrentUserBodyOnboardingSource = {
  gmt: 'gmt',
  integrator: 'integrator',
  'paytrie-mobile': 'paytrie-mobile',
  'paytrie-web': 'paytrie-web',
} as const

/**
 * Satisfies the `additionalInfo` requirement, which applies to users aged 50 or over at signup. Merged into any previously submitted values.
 */
export type UpdateCurrentUserBodyOlderUserInfo = {
  /** @minLength 1 */
  sourceOfFunds?: string
  /** @minLength 1 */
  intendedUseOfUSDC?: string
  /** @minLength 1 */
  walletProvider?: string
  /** @minLength 1 */
  walletAddress?: string
  /** @minLength 1 */
  howDidYouHear?: string
  /** @minLength 1 */
  whoReferredYou?: string
  /** @minLength 1 */
  previousCryptoExperience?: string
}

export type UpdateCurrentUserBody = {
  currentFlow?: UpdateCurrentUserBodyCurrentFlow
  /** @minLength 1 */
  firstName?: string
  /** @minLength 1 */
  lastName?: string
  dob?: string
  /** @minLength 1 */
  addressLine1?: string
  /** @nullable */
  addressLine2?: string | null
  /** @minLength 1 */
  city?: string
  province?: UpdateCurrentUserBodyProvince
  /** @pattern ^[ABCEGHJ-NPRSTVXYabceghj-nprstvxy]\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z][ -]?\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z]\d$ */
  postalCode?: string
  /** @minLength 1 */
  occupation?: string
  /** @minLength 1 */
  purpose?: string
  /** Self-attestation on whether the user is a politically exposed person. Politically exposed persons are not allowed to transact with Paytrie. False means the user is not PEP. */
  pep?: false
  /** Self-attestation on whether the user is a third party determination. Users acting on behalf of a third party are not allowed to transact with Paytrie. False means the user is not TPD. */
  tpd?: false
  /** Channel where the user started onboarding (e.g. `gmt`, `paytrie-web`). Defaults to `paytrie-web` when omitted at user creation. */
  onboardingSource?: UpdateCurrentUserBodyOnboardingSource
  /** Set to true on KYC-refresh submissions. The server records the current server time as the user's KYC refresh timestamp, resetting the refresh window. */
  refreshKyc?: boolean
  /** Satisfies the `additionalInfo` requirement, which applies to users aged 50 or over at signup. Merged into any previously submitted values. */
  olderUserInfo?: UpdateCurrentUserBodyOlderUserInfo
}

export type UpdateCurrentUser200 = {
  success: true
  data: CurrentUser
}

export type CreateCorporation201 = {
  success: true
  data: Corporation
}

export type GetCurrentCorporation200 = {
  success: true
  data: Corporation
}

export type UpdateCurrentCorporation200 = {
  success: true
  data: Corporation
}

export type SubmitCorporationDocuments200 = {
  success: true
  data: Corporation
}

/**
 * PDF, JPEG, PNG, WebP or HEIC/HEIF
 */
export type CreateCorporationDocumentUploadUrlsBodyDocumentsItemContentType =
  (typeof CreateCorporationDocumentUploadUrlsBodyDocumentsItemContentType)[keyof typeof CreateCorporationDocumentUploadUrlsBodyDocumentsItemContentType]

export const CreateCorporationDocumentUploadUrlsBodyDocumentsItemContentType = {
  'image/jpg': 'image/jpg',
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/webp': 'image/webp',
  'image/heic': 'image/heic',
  'image/heif': 'image/heif',
  'application/pdf': 'application/pdf',
} as const

export type CreateCorporationDocumentUploadUrlsBodyDocumentsItem = {
  /**
   * Original filename, for display only. Held as object metadata and written to files.file_name on submission; it does not influence the generated object name.
   * @minLength 1
   * @maxLength 255
   */
  name: string
  /** PDF, JPEG, PNG, WebP or HEIC/HEIF */
  contentType: CreateCorporationDocumentUploadUrlsBodyDocumentsItemContentType
  /**
   * @maximum 10485760
   * @exclusiveMinimum 0
   */
  size: number
}

export type CreateCorporationDocumentUploadUrlsBody = {
  /**
   * @minItems 1
   * @maxItems 5
   */
  documents: CreateCorporationDocumentUploadUrlsBodyDocumentsItem[]
}

export type CreateCorporationDocumentUploadUrls201 = {
  success: true
  data: CorporationDocumentUploadUrls
}

export type SendPhoneVerificationBody = {
  /** @minLength 1 */
  phone: string
}

export type VerifyPhoneBody = {
  /** @minLength 1 */
  code: string
}

export type GetUsersMeKycUrl200 = {
  success: true
  data: KycUrl
}

export type GetCurrentUserRequirements200 = {
  success: true
  data: UserRequirements
}

export type GetUser200 = {
  success: true
  data: UserSummaryWithStatus
}

export type UpdateUserBodyProvince =
  (typeof UpdateUserBodyProvince)[keyof typeof UpdateUserBodyProvince]

export const UpdateUserBodyProvince = {
  ab: 'ab',
  bc: 'bc',
  mb: 'mb',
  nb: 'nb',
  nl: 'nl',
  ns: 'ns',
  nt: 'nt',
  nu: 'nu',
  on: 'on',
  pe: 'pe',
  qc: 'qc',
  sk: 'sk',
  yt: 'yt',
} as const

/**
 * Satisfies the `additionalInfo` requirement, which applies to users aged 50 or over at signup. Merged into any previously submitted values.
 */
export type UpdateUserBodyOlderUserInfo = {
  /** @minLength 1 */
  sourceOfFunds?: string
  /** @minLength 1 */
  intendedUseOfUSDC?: string
  /** @minLength 1 */
  walletProvider?: string
  /** @minLength 1 */
  walletAddress?: string
  /** @minLength 1 */
  howDidYouHear?: string
  /** @minLength 1 */
  whoReferredYou?: string
  /** @minLength 1 */
  previousCryptoExperience?: string
}

export type UpdateUserBody = {
  /** @minLength 1 */
  firstName?: string
  /** @minLength 1 */
  lastName?: string
  dob?: string
  /** @minLength 1 */
  addressLine1?: string
  /** @nullable */
  addressLine2?: string | null
  /** @minLength 1 */
  city?: string
  province?: UpdateUserBodyProvince
  /** @pattern ^[ABCEGHJ-NPRSTVXYabceghj-nprstvxy]\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z][ -]?\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z]\d$ */
  postalCode?: string
  /** @minLength 1 */
  occupation?: string
  /** @minLength 1 */
  purpose?: string
  /** Self-attestation on whether the user is a politically exposed person. Politically exposed persons are not allowed to transact with Paytrie. False means the user is not PEP. */
  pep?: false
  /** Self-attestation on whether the user is a third party determination. Users acting on behalf of a third party are not allowed to transact with Paytrie. False means the user is not TPD. */
  tpd?: false
  /** Satisfies the `additionalInfo` requirement, which applies to users aged 50 or over at signup. Merged into any previously submitted values. */
  olderUserInfo?: UpdateUserBodyOlderUserInfo
}

export type UpdateUser200 = {
  success: true
  data: UserSummaryWithStatus
}

export type GetUserRequirements200 = {
  success: true
  data: UserRequirements
}

export type GetUserKycUrl200 = {
  success: true
  data: KycUrl
}

export type ListUserBankAccounts200 = {
  success: true
  data: BankAccountList
}

export type ImportUserKycBody = {
  type: 'sumsub'
  payload: {
    /** @minLength 1 */
    shareToken: string
  }
}

export type ImportUserKyc200 = {
  success: true
  data: UserSummaryWithStatus
}

export type ImportUserKyc202 = {
  success: true
  data: UserSummaryWithStatus
}

export type FinalizeUserKycDocumentsBody = {
  /**
   * @minItems 1
   * @maxItems 5
   * @items.minLength 1
   */
  objectNames: string[]
}

export type FinalizeUserKycDocuments201 = {
  success: true
  data: KycDocumentsFinalized
}

export type CreateUserKycDocumentUploadUrlsBodyDocumentsItemContentType =
  (typeof CreateUserKycDocumentUploadUrlsBodyDocumentsItemContentType)[keyof typeof CreateUserKycDocumentUploadUrlsBodyDocumentsItemContentType]

export const CreateUserKycDocumentUploadUrlsBodyDocumentsItemContentType = {
  'image/jpg': 'image/jpg',
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/webp': 'image/webp',
  'image/heic': 'image/heic',
  'image/heif': 'image/heif',
  'application/pdf': 'application/pdf',
} as const

export type CreateUserKycDocumentUploadUrlsBodyDocumentsItem = {
  /**
   * Original filename for display only. Stored as GCS object metadata and persisted to files.file_name on finalize. Does not affect the generated object name.
   * @minLength 1
   * @maxLength 255
   */
  name: string
  contentType: CreateUserKycDocumentUploadUrlsBodyDocumentsItemContentType
  /**
   * @maximum 10485760
   * @exclusiveMinimum 0
   */
  size: number
}

export type CreateUserKycDocumentUploadUrlsBody = {
  /**
   * @minItems 1
   * @maxItems 5
   */
  documents: CreateUserKycDocumentUploadUrlsBodyDocumentsItem[]
}

export type CreateUserKycDocumentUploadUrls201 = {
  success: true
  data: KycUploadUrls
}

export type ListUserOtcRequestsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number
  /**
   * @minimum 0
   * @nullable
   */
  offset?: number | null
}

export type ListUserOtcRequests200 = {
  success: true
  data: OtcRequestList
}

export type CreateUserOtcRequest201 = {
  success: true
  data: OtcRequest
}

export type ListUserTransactionsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number
  /**
   * @minimum 0
   * @nullable
   */
  offset?: number | null
}

export type ListUserTransactions200 = {
  success: true
  data: TransactionList
}

export type CreateUserTransaction201 = {
  success: true
  data: Transaction
}

export type CancelUserTransaction200 = {
  success: true
  data: Transaction
}

export type GetWebhookConfiguration200 = {
  success: true
  data: WebhookConfiguration
}

export type SetWebhookConfigurationBody = {
  url: string
}

export type SetWebhookConfiguration200 = {
  success: true
  data: UpsertWebhookConfigurationResult
}

export type SendTestWebhook200 = {
  success: true
  data: WebhookTestResult
}

export type RotateWebhookSigningSecret200 = {
  success: true
  data: WebhookSigningSecret
}

export type requestMagicLinkResponse202 = {
  data: void
  status: 202
}

export type requestMagicLinkResponse422 = {
  data: Error
  status: 422
}

export type requestMagicLinkResponseSuccess = requestMagicLinkResponse202 & {
  headers: Headers
}
export type requestMagicLinkResponseError = requestMagicLinkResponse422 & {
  headers: Headers
}

export type requestMagicLinkResponse =
  | requestMagicLinkResponseSuccess
  | requestMagicLinkResponseError

export const getRequestMagicLinkUrl = () => {
  return `/auth/magic-links`
}

/**
 * Creates an account if the email is unknown and emails a single-use link. The caller supplies a session identifier that the originating tab polls against via POST /auth/tokens. Always returns 202 to avoid account enumeration.
 * @summary Request a passwordless login email
 */
export const requestMagicLink = async (
  requestMagicLinkBody: RequestMagicLinkBody,
  options?: RequestInit
): Promise<requestMagicLinkResponse> => {
  return customFetch<requestMagicLinkResponse>(getRequestMagicLinkUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestMagicLinkBody),
  })
}

export type denyMagicLinkResponse204 = {
  data: void
  status: 204
}

export type denyMagicLinkResponse401 = {
  data: Error
  status: 401
}

export type denyMagicLinkResponse422 = {
  data: Error
  status: 422
}

export type denyMagicLinkResponseSuccess = denyMagicLinkResponse204 & {
  headers: Headers
}
export type denyMagicLinkResponseError = (
  | denyMagicLinkResponse401
  | denyMagicLinkResponse422
) & {
  headers: Headers
}

export type denyMagicLinkResponse =
  | denyMagicLinkResponseSuccess
  | denyMagicLinkResponseError

export const getDenyMagicLinkUrl = (
  verifier: string,
  params: DenyMagicLinkParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/auth/magic-links/${verifier}?${stringifiedParams}`
    : `/auth/magic-links/${verifier}`
}

/**
 * Called by the page the email link opens when the recipient rejects the sign-in request. Marks the session denied so the original client, on its next POST /auth/tokens poll, receives { status: "denied" } instead of waiting for the link to expire.
 * @summary Deny a magic link
 */
export const denyMagicLink = async (
  verifier: string,
  params: DenyMagicLinkParams,
  options?: RequestInit
): Promise<denyMagicLinkResponse> => {
  return customFetch<denyMagicLinkResponse>(
    getDenyMagicLinkUrl(verifier, params),
    {
      ...options,
      method: 'DELETE',
    }
  )
}

export type getMagicLinkResponse200 = {
  data: GetMagicLink200
  status: 200
}

export type getMagicLinkResponse401 = {
  data: Error
  status: 401
}

export type getMagicLinkResponse422 = {
  data: Error
  status: 422
}

export type getMagicLinkResponseSuccess = getMagicLinkResponse200 & {
  headers: Headers
}
export type getMagicLinkResponseError = (
  | getMagicLinkResponse401
  | getMagicLinkResponse422
) & {
  headers: Headers
}

export type getMagicLinkResponse =
  | getMagicLinkResponseSuccess
  | getMagicLinkResponseError

export const getGetMagicLinkUrl = (
  verifier: string,
  params: GetMagicLinkParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/auth/magic-links/${verifier}?${stringifiedParams}`
    : `/auth/magic-links/${verifier}`
}

/**
 * Non-mutating read used by the page the email link opens to render an approval UI. Returns the IP, location, and timestamp the sign-in was requested from so the recipient can decide whether to approve or deny. Returns 401 if the link is already consumed, denied, or expired.
 * @summary Fetch details about a pending magic link
 */
export const getMagicLink = async (
  verifier: string,
  params: GetMagicLinkParams,
  options?: RequestInit
): Promise<getMagicLinkResponse> => {
  return customFetch<getMagicLinkResponse>(
    getGetMagicLinkUrl(verifier, params),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type approveMagicLinkResponse200 = {
  data: ApproveMagicLink200
  status: 200
}

export type approveMagicLinkResponse401 = {
  data: Error
  status: 401
}

export type approveMagicLinkResponse422 = {
  data: Error
  status: 422
}

export type approveMagicLinkResponseSuccess = approveMagicLinkResponse200 & {
  headers: Headers
}
export type approveMagicLinkResponseError = (
  | approveMagicLinkResponse401
  | approveMagicLinkResponse422
) & {
  headers: Headers
}

export type approveMagicLinkResponse =
  | approveMagicLinkResponseSuccess
  | approveMagicLinkResponseError

export const getApproveMagicLinkUrl = (verifier: string) => {
  return `/auth/magic-links/${verifier}/approve`
}

/**
 * Called by the page the email link opens when the recipient approves the sign-in request. Marks the session approved and issues a JWT to the approving device, so the user is logged in directly on that tab. The originating tab also receives a JWT on its next POST /auth/tokens poll.
 * @summary Approve a magic link
 */
export const approveMagicLink = async (
  verifier: string,
  approveMagicLinkBody: ApproveMagicLinkBody,
  options?: RequestInit
): Promise<approveMagicLinkResponse> => {
  return customFetch<approveMagicLinkResponse>(
    getApproveMagicLinkUrl(verifier),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(approveMagicLinkBody),
    }
  )
}

export type pollAuthTokenResponse200 = {
  data: PollAuthToken200
  status: 200
}

export type pollAuthTokenResponse401 = {
  data: Error
  status: 401
}

export type pollAuthTokenResponse422 = {
  data: Error
  status: 422
}

export type pollAuthTokenResponseSuccess = pollAuthTokenResponse200 & {
  headers: Headers
}
export type pollAuthTokenResponseError = (
  | pollAuthTokenResponse401
  | pollAuthTokenResponse422
) & {
  headers: Headers
}

export type pollAuthTokenResponse =
  | pollAuthTokenResponseSuccess
  | pollAuthTokenResponseError

export const getPollAuthTokenUrl = () => {
  return `/auth/tokens`
}

/**
 * The original client polls this endpoint with the sessionId it passed to POST /auth/magic-links. Returns { status: "pending" } until the link has been acted on, { status: "verified", accessToken, ... } once the recipient approves via POST /auth/magic-links/{verifier}/approve, or { status: "denied" } if the recipient rejects via DELETE /auth/magic-links/{verifier}. The session is single-use — a second call after a verified response returns 401.
 * @summary Poll for an access token once the magic link is clicked
 */
export const pollAuthToken = async (
  pollAuthTokenBody: PollAuthTokenBody,
  options?: RequestInit
): Promise<pollAuthTokenResponse> => {
  return customFetch<pollAuthTokenResponse>(getPollAuthTokenUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pollAuthTokenBody),
  })
}

export type sendLoginCodeResponse202 = {
  data: void
  status: 202
}

export type sendLoginCodeResponse422 = {
  data: Error
  status: 422
}

export type sendLoginCodeResponseSuccess = sendLoginCodeResponse202 & {
  headers: Headers
}
export type sendLoginCodeResponseError = sendLoginCodeResponse422 & {
  headers: Headers
}

export type sendLoginCodeResponse =
  | sendLoginCodeResponseSuccess
  | sendLoginCodeResponseError

export const getSendLoginCodeUrl = () => {
  return `/auth/login-codes`
}

/**
 * Emails a short numeric login code to an existing user. The user hands the code back to the integrator, which exchanges it for an access token via POST /auth/login-codes/verify. Always returns 202 to avoid account enumeration.
 * @summary Send an OTP to a user
 */
export const sendLoginCode = async (
  sendLoginCodeBody: SendLoginCodeBody,
  options?: RequestInit
): Promise<sendLoginCodeResponse> => {
  return customFetch<sendLoginCodeResponse>(getSendLoginCodeUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendLoginCodeBody),
  })
}

export type verifyLoginCodeResponse200 = {
  data: VerifyLoginCode200
  status: 200
}

export type verifyLoginCodeResponse401 = {
  data: Error
  status: 401
}

export type verifyLoginCodeResponse422 = {
  data: Error
  status: 422
}

export type verifyLoginCodeResponseSuccess = verifyLoginCodeResponse200 & {
  headers: Headers
}
export type verifyLoginCodeResponseError = (
  | verifyLoginCodeResponse401
  | verifyLoginCodeResponse422
) & {
  headers: Headers
}

export type verifyLoginCodeResponse =
  | verifyLoginCodeResponseSuccess
  | verifyLoginCodeResponseError

export const getVerifyLoginCodeUrl = () => {
  return `/auth/login-codes/verify`
}

/**
 * Verifies a login code emailed via POST /auth/login-codes and returns an access token for the user.
 * @summary Exchange an OTP for an access token
 */
export const verifyLoginCode = async (
  verifyLoginCodeBody: VerifyLoginCodeBody,
  options?: RequestInit
): Promise<verifyLoginCodeResponse> => {
  return customFetch<verifyLoginCodeResponse>(getVerifyLoginCodeUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyLoginCodeBody),
  })
}

export type requestUserLinkResponse202 = {
  data: void
  status: 202
}

export type requestUserLinkResponse400 = {
  data: Error
  status: 400
}

export type requestUserLinkResponse403 = {
  data: Error
  status: 403
}

export type requestUserLinkResponse422 = {
  data: Error
  status: 422
}

export type requestUserLinkResponse429 = {
  data: Error
  status: 429
}

export type requestUserLinkResponseSuccess = requestUserLinkResponse202 & {
  headers: Headers
}
export type requestUserLinkResponseError = (
  | requestUserLinkResponse400
  | requestUserLinkResponse403
  | requestUserLinkResponse422
  | requestUserLinkResponse429
) & {
  headers: Headers
}

export type requestUserLinkResponse =
  | requestUserLinkResponseSuccess
  | requestUserLinkResponseError

export const getRequestUserLinkUrl = () => {
  return `/auth/integrator-link`
}

/**
 * Emails the user a link code. The user passes that code back to you, and you exchange it via POST /auth/integrator-link/verify to establish the link. Always returns 202, whether or not the email belongs to a Paytrie user. No code is sent when the user has already linked to you.
 * @summary Ask a user to link their account to your integration
 */
export const requestUserLink = async (
  requestUserLinkBody: RequestUserLinkBody,
  options?: RequestInit
): Promise<requestUserLinkResponse> => {
  return customFetch<requestUserLinkResponse>(getRequestUserLinkUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestUserLinkBody),
  })
}

export type verifyUserLinkResponse200 = {
  data: VerifyUserLink200
  status: 200
}

export type verifyUserLinkResponse400 = {
  data: Error
  status: 400
}

export type verifyUserLinkResponse401 = {
  data: Error
  status: 401
}

export type verifyUserLinkResponse403 = {
  data: Error
  status: 403
}

export type verifyUserLinkResponse422 = {
  data: Error
  status: 422
}

export type verifyUserLinkResponse429 = {
  data: Error
  status: 429
}

export type verifyUserLinkResponseSuccess = verifyUserLinkResponse200 & {
  headers: Headers
}
export type verifyUserLinkResponseError = (
  | verifyUserLinkResponse400
  | verifyUserLinkResponse401
  | verifyUserLinkResponse403
  | verifyUserLinkResponse422
  | verifyUserLinkResponse429
) & {
  headers: Headers
}

export type verifyUserLinkResponse =
  | verifyUserLinkResponseSuccess
  | verifyUserLinkResponseError

export const getVerifyUserLinkUrl = () => {
  return `/auth/integrator-link/verify`
}

/**
 * Exchanges the link code Paytrie emailed to the user for a confirmed link between that user and your integration. Once linked, you may act on the user’s behalf until the link is revoked. Codes are single use and expire; a code that has expired or been used returns 401.
 * @summary Exchange a link code to establish the link
 */
export const verifyUserLink = async (
  verifyUserLinkBody: VerifyUserLinkBody,
  options?: RequestInit
): Promise<verifyUserLinkResponse> => {
  return customFetch<verifyUserLinkResponse>(getVerifyUserLinkUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyUserLinkBody),
  })
}

export type recordEventResponse202 = {
  data: void
  status: 202
}

export type recordEventResponse422 = {
  data: Error
  status: 422
}

export type recordEventResponseSuccess = recordEventResponse202 & {
  headers: Headers
}
export type recordEventResponseError = recordEventResponse422 & {
  headers: Headers
}

export type recordEventResponse =
  | recordEventResponseSuccess
  | recordEventResponseError

export const getRecordEventUrl = () => {
  return `/events`
}

/**
 * Records a single product analytics event. JWT is optional: when a valid token is present, the user is derived server-side from it. When it is absent — or cannot be verified — the event is recorded as anonymous against the integrator API key rather than being rejected.
 * @summary Record a product analytics event
 */
export const recordEvent = async (
  recordEventRequest: RecordEventRequest,
  options?: RequestInit
): Promise<recordEventResponse> => {
  return customFetch<recordEventResponse>(getRecordEventUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordEventRequest),
  })
}

export type getFeatureFlagsResponse200 = {
  data: GetFeatureFlags200
  status: 200
}

export type getFeatureFlagsResponse422 = {
  data: Error
  status: 422
}

export type getFeatureFlagsResponseSuccess = getFeatureFlagsResponse200 & {
  headers: Headers
}
export type getFeatureFlagsResponseError = getFeatureFlagsResponse422 & {
  headers: Headers
}

export type getFeatureFlagsResponse =
  | getFeatureFlagsResponseSuccess
  | getFeatureFlagsResponseError

export const getGetFeatureFlagsUrl = (params: GetFeatureFlagsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/feature-flags?${stringifiedParams}`
    : `/feature-flags`
}

/**
 * Returns the status of the requested feature flags. When a user access token is supplied, per-user overrides are applied; otherwise the global values are returned.
 * @summary Check the status of feature flags
 */
export const getFeatureFlags = async (
  params: GetFeatureFlagsParams,
  options?: RequestInit
): Promise<getFeatureFlagsResponse> => {
  return customFetch<getFeatureFlagsResponse>(getGetFeatureFlagsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export type getLimitsResponse200 = {
  data: GetLimits200
  status: 200
}

export type getLimitsResponse500 = {
  data: Error
  status: 500
}

export type getLimitsResponseSuccess = getLimitsResponse200 & {
  headers: Headers
}
export type getLimitsResponseError = getLimitsResponse500 & {
  headers: Headers
}

export type getLimitsResponse =
  | getLimitsResponseSuccess
  | getLimitsResponseError

export const getGetLimitsUrl = () => {
  return `/limits`
}

/**
 * @summary Get minimum and maximum limits per currency
 */
export const getLimits = async (
  options?: RequestInit
): Promise<getLimitsResponse> => {
  return customFetch<getLimitsResponse>(getGetLimitsUrl(), {
    ...options,
    method: 'GET',
  })
}

export type listMaintenanceWindowsResponse200 = {
  data: ListMaintenanceWindows200
  status: 200
}

export type listMaintenanceWindowsResponse422 = {
  data: Error
  status: 422
}

export type listMaintenanceWindowsResponseSuccess =
  listMaintenanceWindowsResponse200 & {
    headers: Headers
  }
export type listMaintenanceWindowsResponseError =
  listMaintenanceWindowsResponse422 & {
    headers: Headers
  }

export type listMaintenanceWindowsResponse =
  | listMaintenanceWindowsResponseSuccess
  | listMaintenanceWindowsResponseError

export const getListMaintenanceWindowsUrl = (
  params?: ListMaintenanceWindowsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/maintenance-windows?${stringifiedParams}`
    : `/maintenance-windows`
}

/**
 * Returns upcoming, in-progress and recently completed maintenance windows that stop new transactions from being created, latest start first. While a window is in progress, creating a transaction or OTC request returns 503. No authentication is required, so a status page or banner can call it directly.
 * @summary List maintenance windows
 */
export const listMaintenanceWindows = async (
  params?: ListMaintenanceWindowsParams,
  options?: RequestInit
): Promise<listMaintenanceWindowsResponse> => {
  return customFetch<listMaintenanceWindowsResponse>(
    getListMaintenanceWindowsUrl(params),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type getWidgetConfigResponse200 = {
  data: GetWidgetConfig200
  status: 200
}

export type getWidgetConfigResponseSuccess = getWidgetConfigResponse200 & {
  headers: Headers
}
export type getWidgetConfigResponse = getWidgetConfigResponseSuccess

export const getGetWidgetConfigUrl = () => {
  return `/widget-config`
}

/**
 * Resolves the request's Origin against the widget deployments registered to integrators. A registered origin gets its integrator and completion redirect; any other origin is a first-party deployment and gets nulls.
 * @summary Describe the widget deployment making the request
 */
export const getWidgetConfig = async (
  options?: RequestInit
): Promise<getWidgetConfigResponse> => {
  return customFetch<getWidgetConfigResponse>(getGetWidgetConfigUrl(), {
    ...options,
    method: 'GET',
  })
}

export type listOtcRequestsResponse200 = {
  data: ListOtcRequests200
  status: 200
}

export type listOtcRequestsResponse401 = {
  data: Error
  status: 401
}

export type listOtcRequestsResponse404 = {
  data: Error
  status: 404
}

export type listOtcRequestsResponseSuccess = listOtcRequestsResponse200 & {
  headers: Headers
}
export type listOtcRequestsResponseError = (
  | listOtcRequestsResponse401
  | listOtcRequestsResponse404
) & {
  headers: Headers
}

export type listOtcRequestsResponse =
  | listOtcRequestsResponseSuccess
  | listOtcRequestsResponseError

export const getListOtcRequestsUrl = (params?: ListOtcRequestsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/otc-requests?${stringifiedParams}`
    : `/otc-requests`
}

/**
 * @summary List OTC requests for the user
 */
export const listOtcRequests = async (
  params?: ListOtcRequestsParams,
  options?: RequestInit
): Promise<listOtcRequestsResponse> => {
  return customFetch<listOtcRequestsResponse>(getListOtcRequestsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export type createOtcRequestResponse201 = {
  data: CreateOtcRequest201
  status: 201
}

export type createOtcRequestResponse400 = {
  data: Error
  status: 400
}

export type createOtcRequestResponse401 = {
  data: Error
  status: 401
}

export type createOtcRequestResponse403 = {
  data: Error
  status: 403
}

export type createOtcRequestResponse404 = {
  data: Error
  status: 404
}

export type createOtcRequestResponse429 = {
  data: Error
  status: 429
}

export type createOtcRequestResponse503 = {
  data: Error
  status: 503
}

export type createOtcRequestResponseSuccess = createOtcRequestResponse201 & {
  headers: Headers
}
export type createOtcRequestResponseError = (
  | createOtcRequestResponse400
  | createOtcRequestResponse401
  | createOtcRequestResponse403
  | createOtcRequestResponse404
  | createOtcRequestResponse429
  | createOtcRequestResponse503
) & {
  headers: Headers
}

export type createOtcRequestResponse =
  | createOtcRequestResponseSuccess
  | createOtcRequestResponseError

export const getCreateOtcRequestUrl = () => {
  return `/otc-requests`
}

/**
 * @summary Create an OTC request
 */
export const createOtcRequest = async (
  createOtcRequest: CreateOtcRequest,
  options?: RequestInit
): Promise<createOtcRequestResponse> => {
  return customFetch<createOtcRequestResponse>(getCreateOtcRequestUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOtcRequest),
  })
}

export type getOtcWireInstructionsResponse200 = {
  data: GetOtcWireInstructions200
  status: 200
}

export type getOtcWireInstructionsResponse401 = {
  data: Error
  status: 401
}

export type getOtcWireInstructionsResponse404 = {
  data: Error
  status: 404
}

export type getOtcWireInstructionsResponse503 = {
  data: Error
  status: 503
}

export type getOtcWireInstructionsResponseSuccess =
  getOtcWireInstructionsResponse200 & {
    headers: Headers
  }
export type getOtcWireInstructionsResponseError = (
  | getOtcWireInstructionsResponse401
  | getOtcWireInstructionsResponse404
  | getOtcWireInstructionsResponse503
) & {
  headers: Headers
}

export type getOtcWireInstructionsResponse =
  | getOtcWireInstructionsResponseSuccess
  | getOtcWireInstructionsResponseError

export const getGetOtcWireInstructionsUrl = () => {
  return `/otc-requests/wire-instructions`
}

/**
 * @summary Get OTC wire transfer instructions
 */
export const getOtcWireInstructions = async (
  options?: RequestInit
): Promise<getOtcWireInstructionsResponse> => {
  return customFetch<getOtcWireInstructionsResponse>(
    getGetOtcWireInstructionsUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type getOtcRequestResponse200 = {
  data: GetOtcRequest200
  status: 200
}

export type getOtcRequestResponse401 = {
  data: Error
  status: 401
}

export type getOtcRequestResponse404 = {
  data: Error
  status: 404
}

export type getOtcRequestResponseSuccess = getOtcRequestResponse200 & {
  headers: Headers
}
export type getOtcRequestResponseError = (
  | getOtcRequestResponse401
  | getOtcRequestResponse404
) & {
  headers: Headers
}

export type getOtcRequestResponse =
  | getOtcRequestResponseSuccess
  | getOtcRequestResponseError

export const getGetOtcRequestUrl = (otcRequestId: string) => {
  return `/otc-requests/${otcRequestId}`
}

/**
 * @summary Get an OTC request by ID
 */
export const getOtcRequest = async (
  otcRequestId: string,
  options?: RequestInit
): Promise<getOtcRequestResponse> => {
  return customFetch<getOtcRequestResponse>(getGetOtcRequestUrl(otcRequestId), {
    ...options,
    method: 'GET',
  })
}

export type getQuotesResponse200 = {
  data: GetQuotes200
  status: 200
}

export type getQuotesResponse401 = {
  data: Error
  status: 401
}

export type getQuotesResponseSuccess = getQuotesResponse200 & {
  headers: Headers
}
export type getQuotesResponseError = getQuotesResponse401 & {
  headers: Headers
}

export type getQuotesResponse =
  | getQuotesResponseSuccess
  | getQuotesResponseError

export const getGetQuotesUrl = (params?: GetQuotesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/quotes?${stringifiedParams}`
    : `/quotes`
}

/**
 * Returns a quote for the pair and amount with a fee breakdown. Send your x-api-key to price with your fee terms; without a key the quote uses default terms.
 * @summary Get latest quote
 */
export const getQuotes = async (
  params?: GetQuotesParams,
  options?: RequestInit
): Promise<getQuotesResponse> => {
  return customFetch<getQuotesResponse>(getGetQuotesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export type listTransactionsResponse200 = {
  data: ListTransactions200
  status: 200
}

export type listTransactionsResponse401 = {
  data: Error
  status: 401
}

export type listTransactionsResponseSuccess = listTransactionsResponse200 & {
  headers: Headers
}
export type listTransactionsResponseError = listTransactionsResponse401 & {
  headers: Headers
}

export type listTransactionsResponse =
  | listTransactionsResponseSuccess
  | listTransactionsResponseError

export const getListTransactionsUrl = (params?: ListTransactionsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/transactions?${stringifiedParams}`
    : `/transactions`
}

/**
 * @summary List transactions for the user
 */
export const listTransactions = async (
  params?: ListTransactionsParams,
  options?: RequestInit
): Promise<listTransactionsResponse> => {
  return customFetch<listTransactionsResponse>(getListTransactionsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export type createTransactionResponse201 = {
  data: CreateTransaction201
  status: 201
}

export type createTransactionResponse400 = {
  data: Error
  status: 400
}

export type createTransactionResponse401 = {
  data: Error
  status: 401
}

export type createTransactionResponse403 = {
  data: Error
  status: 403
}

export type createTransactionResponse422 = {
  data: Error
  status: 422
}

export type createTransactionResponse500 = {
  data: Error
  status: 500
}

export type createTransactionResponse503 = {
  data: Error
  status: 503
}

export type createTransactionResponseSuccess = createTransactionResponse201 & {
  headers: Headers
}
export type createTransactionResponseError = (
  | createTransactionResponse400
  | createTransactionResponse401
  | createTransactionResponse403
  | createTransactionResponse422
  | createTransactionResponse500
  | createTransactionResponse503
) & {
  headers: Headers
}

export type createTransactionResponse =
  | createTransactionResponseSuccess
  | createTransactionResponseError

export const getCreateTransactionUrl = () => {
  return `/transactions`
}

/**
 * @summary Create a transaction
 */
export const createTransaction = async (
  createTransactionRequest: CreateTransactionRequest,
  options?: RequestInit
): Promise<createTransactionResponse> => {
  return customFetch<createTransactionResponse>(getCreateTransactionUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTransactionRequest),
  })
}

export type getTransactionResponse200 = {
  data: GetTransaction200
  status: 200
}

export type getTransactionResponse404 = {
  data: Error
  status: 404
}

export type getTransactionResponseSuccess = getTransactionResponse200 & {
  headers: Headers
}
export type getTransactionResponseError = getTransactionResponse404 & {
  headers: Headers
}

export type getTransactionResponse =
  | getTransactionResponseSuccess
  | getTransactionResponseError

export const getGetTransactionUrl = (txId: string) => {
  return `/transactions/${txId}`
}

/**
 * @summary Get a transaction by ID
 */
export const getTransaction = async (
  txId: string,
  options?: RequestInit
): Promise<getTransactionResponse> => {
  return customFetch<getTransactionResponse>(getGetTransactionUrl(txId), {
    ...options,
    method: 'GET',
  })
}

export type cancelTransactionResponse200 = {
  data: CancelTransaction200
  status: 200
}

export type cancelTransactionResponse401 = {
  data: Error
  status: 401
}

export type cancelTransactionResponse404 = {
  data: Error
  status: 404
}

export type cancelTransactionResponse409 = {
  data: Error
  status: 409
}

export type cancelTransactionResponseSuccess = cancelTransactionResponse200 & {
  headers: Headers
}
export type cancelTransactionResponseError = (
  | cancelTransactionResponse401
  | cancelTransactionResponse404
  | cancelTransactionResponse409
) & {
  headers: Headers
}

export type cancelTransactionResponse =
  | cancelTransactionResponseSuccess
  | cancelTransactionResponseError

export const getCancelTransactionUrl = (txId: string) => {
  return `/transactions/${txId}/cancel`
}

/**
 * @summary Cancel a transaction
 */
export const cancelTransaction = async (
  txId: string,
  options?: RequestInit
): Promise<cancelTransactionResponse> => {
  return customFetch<cancelTransactionResponse>(getCancelTransactionUrl(txId), {
    ...options,
    method: 'PUT',
  })
}

export type listUsersResponse200 = {
  data: ListUsers200
  status: 200
}

export type listUsersResponse403 = {
  data: Error
  status: 403
}

export type listUsersResponse422 = {
  data: Error
  status: 422
}

export type listUsersResponseSuccess = listUsersResponse200 & {
  headers: Headers
}
export type listUsersResponseError = (
  | listUsersResponse403
  | listUsersResponse422
) & {
  headers: Headers
}

export type listUsersResponse =
  | listUsersResponseSuccess
  | listUsersResponseError

export const getListUsersUrl = (params: ListUsersParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/users?${stringifiedParams}` : `/users`
}

/**
 * Looks up a user by email across the platform, regardless of which integrator they belong to. Returns a single-element array holding only the id of the matching user, or an empty array when the email is not registered.
 * @summary Search users by email
 */
export const listUsers = async (
  params: ListUsersParams,
  options?: RequestInit
): Promise<listUsersResponse> => {
  return customFetch<listUsersResponse>(getListUsersUrl(params), {
    ...options,
    method: 'GET',
  })
}

export type createUserResponse201 = {
  data: CreateUser201
  status: 201
}

export type createUserResponse409 = {
  data: Error
  status: 409
}

export type createUserResponse422 = {
  data: Error
  status: 422
}

export type createUserResponseSuccess = createUserResponse201 & {
  headers: Headers
}
export type createUserResponseError = (
  | createUserResponse409
  | createUserResponse422
) & {
  headers: Headers
}

export type createUserResponse =
  | createUserResponseSuccess
  | createUserResponseError

export const getCreateUserUrl = () => {
  return `/users`
}

/**
 * @summary Create a new user
 */
export const createUser = async (
  createUserBody: CreateUserBody,
  options?: RequestInit
): Promise<createUserResponse> => {
  return customFetch<createUserResponse>(getCreateUserUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUserBody),
  })
}

export type getCurrentUserResponse200 = {
  data: GetCurrentUser200
  status: 200
}

export type getCurrentUserResponse401 = {
  data: Error
  status: 401
}

export type getCurrentUserResponse404 = {
  data: Error
  status: 404
}

export type getCurrentUserResponseSuccess = getCurrentUserResponse200 & {
  headers: Headers
}
export type getCurrentUserResponseError = (
  | getCurrentUserResponse401
  | getCurrentUserResponse404
) & {
  headers: Headers
}

export type getCurrentUserResponse =
  | getCurrentUserResponseSuccess
  | getCurrentUserResponseError

export const getGetCurrentUserUrl = () => {
  return `/users/me`
}

/**
 * @summary Get the authenticated user
 */
export const getCurrentUser = async (
  options?: RequestInit
): Promise<getCurrentUserResponse> => {
  return customFetch<getCurrentUserResponse>(getGetCurrentUserUrl(), {
    ...options,
    method: 'GET',
  })
}

export type updateCurrentUserResponse200 = {
  data: UpdateCurrentUser200
  status: 200
}

export type updateCurrentUserResponse400 = {
  data: Error
  status: 400
}

export type updateCurrentUserResponse401 = {
  data: Error
  status: 401
}

export type updateCurrentUserResponse409 = {
  data: Error
  status: 409
}

export type updateCurrentUserResponse422 = {
  data: Error
  status: 422
}

export type updateCurrentUserResponseSuccess = updateCurrentUserResponse200 & {
  headers: Headers
}
export type updateCurrentUserResponseError = (
  | updateCurrentUserResponse400
  | updateCurrentUserResponse401
  | updateCurrentUserResponse409
  | updateCurrentUserResponse422
) & {
  headers: Headers
}

export type updateCurrentUserResponse =
  | updateCurrentUserResponseSuccess
  | updateCurrentUserResponseError

export const getUpdateCurrentUserUrl = () => {
  return `/users/me`
}

/**
 * @summary Update the authenticated user's onboarding fields
 */
export const updateCurrentUser = async (
  updateCurrentUserBody: UpdateCurrentUserBody,
  options?: RequestInit
): Promise<updateCurrentUserResponse> => {
  return customFetch<updateCurrentUserResponse>(getUpdateCurrentUserUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCurrentUserBody),
  })
}

export type createCorporationResponse201 = {
  data: CreateCorporation201
  status: 201
}

export type createCorporationResponse400 = {
  data: Error
  status: 400
}

export type createCorporationResponse401 = {
  data: Error
  status: 401
}

export type createCorporationResponse409 = {
  data: Error
  status: 409
}

export type createCorporationResponseSuccess = createCorporationResponse201 & {
  headers: Headers
}
export type createCorporationResponseError = (
  | createCorporationResponse400
  | createCorporationResponse401
  | createCorporationResponse409
) & {
  headers: Headers
}

export type createCorporationResponse =
  | createCorporationResponseSuccess
  | createCorporationResponseError

export const getCreateCorporationUrl = () => {
  return `/users/me/corporation`
}

/**
 * Only the corporation name, number and email are required. Send every other detail in the same request to create a complete enrollment in one call, or fill them in later with PATCH while the enrollment is a draft.
 * @summary Start a corporate enrollment for the authenticated user
 */
export const createCorporation = async (
  createCorporationRequest: CreateCorporationRequest,
  options?: RequestInit
): Promise<createCorporationResponse> => {
  return customFetch<createCorporationResponse>(getCreateCorporationUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCorporationRequest),
  })
}

export type getCurrentCorporationResponse200 = {
  data: GetCurrentCorporation200
  status: 200
}

export type getCurrentCorporationResponse401 = {
  data: Error
  status: 401
}

export type getCurrentCorporationResponse404 = {
  data: Error
  status: 404
}

export type getCurrentCorporationResponseSuccess =
  getCurrentCorporationResponse200 & {
    headers: Headers
  }
export type getCurrentCorporationResponseError = (
  | getCurrentCorporationResponse401
  | getCurrentCorporationResponse404
) & {
  headers: Headers
}

export type getCurrentCorporationResponse =
  | getCurrentCorporationResponseSuccess
  | getCurrentCorporationResponseError

export const getGetCurrentCorporationUrl = () => {
  return `/users/me/corporation`
}

/**
 * @summary Get the authenticated user's corporate enrollment
 */
export const getCurrentCorporation = async (
  options?: RequestInit
): Promise<getCurrentCorporationResponse> => {
  return customFetch<getCurrentCorporationResponse>(
    getGetCurrentCorporationUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type updateCurrentCorporationResponse200 = {
  data: UpdateCurrentCorporation200
  status: 200
}

export type updateCurrentCorporationResponse400 = {
  data: Error
  status: 400
}

export type updateCurrentCorporationResponse401 = {
  data: Error
  status: 401
}

export type updateCurrentCorporationResponse403 = {
  data: Error
  status: 403
}

export type updateCurrentCorporationResponse404 = {
  data: Error
  status: 404
}

export type updateCurrentCorporationResponse409 = {
  data: Error
  status: 409
}

export type updateCurrentCorporationResponseSuccess =
  updateCurrentCorporationResponse200 & {
    headers: Headers
  }
export type updateCurrentCorporationResponseError = (
  | updateCurrentCorporationResponse400
  | updateCurrentCorporationResponse401
  | updateCurrentCorporationResponse403
  | updateCurrentCorporationResponse404
  | updateCurrentCorporationResponse409
) & {
  headers: Headers
}

export type updateCurrentCorporationResponse =
  | updateCurrentCorporationResponseSuccess
  | updateCurrentCorporationResponseError

export const getUpdateCurrentCorporationUrl = () => {
  return `/users/me/corporation`
}

/**
 * Optional. Corrects or completes an enrollment while it is a draft, for example after a submission fails with 422 naming missing fields. Updating never submits the enrollment, and it is refused once the enrollment is in review.
 * @summary Update the authenticated user's corporate enrollment
 */
export const updateCurrentCorporation = async (
  updateCorporationRequest: UpdateCorporationRequest,
  options?: RequestInit
): Promise<updateCurrentCorporationResponse> => {
  return customFetch<updateCurrentCorporationResponse>(
    getUpdateCurrentCorporationUrl(),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(updateCorporationRequest),
    }
  )
}

export type submitCorporationDocumentsResponse200 = {
  data: SubmitCorporationDocuments200
  status: 200
}

export type submitCorporationDocumentsResponse401 = {
  data: Error
  status: 401
}

export type submitCorporationDocumentsResponse403 = {
  data: Error
  status: 403
}

export type submitCorporationDocumentsResponse404 = {
  data: Error
  status: 404
}

export type submitCorporationDocumentsResponse422 = {
  data: Error
  status: 422
}

export type submitCorporationDocumentsResponseSuccess =
  submitCorporationDocumentsResponse200 & {
    headers: Headers
  }
export type submitCorporationDocumentsResponseError = (
  | submitCorporationDocumentsResponse401
  | submitCorporationDocumentsResponse403
  | submitCorporationDocumentsResponse404
  | submitCorporationDocumentsResponse422
) & {
  headers: Headers
}

export type submitCorporationDocumentsResponse =
  | submitCorporationDocumentsResponseSuccess
  | submitCorporationDocumentsResponseError

export const getSubmitCorporationDocumentsUrl = () => {
  return `/users/me/corporation/documents`
}

/**
 * Include the certificate of incorporation and the articles of incorporation. Every detail the review needs must already be set on the enrollment, otherwise the request fails with 422 naming the missing fields. On success the enrollment moves to `in-review`; creating or updating it never does. Once it is in review, add further documents with the additional-documents request instead: calling this again replaces the documents on file.
 * @summary Submit incorporation documents and enter review
 */
export const submitCorporationDocuments = async (
  submitCorporationDocumentsRequest: SubmitCorporationDocumentsRequest,
  options?: RequestInit
): Promise<submitCorporationDocumentsResponse> => {
  return customFetch<submitCorporationDocumentsResponse>(
    getSubmitCorporationDocumentsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(submitCorporationDocumentsRequest),
    }
  )
}

export type createCorporationDocumentUploadUrlsResponse201 = {
  data: CreateCorporationDocumentUploadUrls201
  status: 201
}

export type createCorporationDocumentUploadUrlsResponse401 = {
  data: Error
  status: 401
}

export type createCorporationDocumentUploadUrlsResponse404 = {
  data: Error
  status: 404
}

export type createCorporationDocumentUploadUrlsResponseSuccess =
  createCorporationDocumentUploadUrlsResponse201 & {
    headers: Headers
  }
export type createCorporationDocumentUploadUrlsResponseError = (
  | createCorporationDocumentUploadUrlsResponse401
  | createCorporationDocumentUploadUrlsResponse404
) & {
  headers: Headers
}

export type createCorporationDocumentUploadUrlsResponse =
  | createCorporationDocumentUploadUrlsResponseSuccess
  | createCorporationDocumentUploadUrlsResponseError

export const getCreateCorporationDocumentUploadUrlsUrl = () => {
  return `/users/me/corporation/documents/upload-urls`
}

/**
 * PUT each file to its `uploadUrl` with the `requiredHeaders`, then send the returned object names as `objectNames` to submit the enrollment or add documents to it.
 * @summary Request signed URLs to upload corporate documents
 */
export const createCorporationDocumentUploadUrls = async (
  createCorporationDocumentUploadUrlsBody: CreateCorporationDocumentUploadUrlsBody,
  options?: RequestInit
): Promise<createCorporationDocumentUploadUrlsResponse> => {
  return customFetch<createCorporationDocumentUploadUrlsResponse>(
    getCreateCorporationDocumentUploadUrlsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createCorporationDocumentUploadUrlsBody),
    }
  )
}

export type addCorporationAdditionalDocumentsResponse204 = {
  data: void
  status: 204
}

export type addCorporationAdditionalDocumentsResponse401 = {
  data: Error
  status: 401
}

export type addCorporationAdditionalDocumentsResponse403 = {
  data: Error
  status: 403
}

export type addCorporationAdditionalDocumentsResponse404 = {
  data: Error
  status: 404
}

export type addCorporationAdditionalDocumentsResponse409 = {
  data: Error
  status: 409
}

export type addCorporationAdditionalDocumentsResponse422 = {
  data: Error
  status: 422
}

export type addCorporationAdditionalDocumentsResponseSuccess =
  addCorporationAdditionalDocumentsResponse204 & {
    headers: Headers
  }
export type addCorporationAdditionalDocumentsResponseError = (
  | addCorporationAdditionalDocumentsResponse401
  | addCorporationAdditionalDocumentsResponse403
  | addCorporationAdditionalDocumentsResponse404
  | addCorporationAdditionalDocumentsResponse409
  | addCorporationAdditionalDocumentsResponse422
) & {
  headers: Headers
}

export type addCorporationAdditionalDocumentsResponse =
  | addCorporationAdditionalDocumentsResponseSuccess
  | addCorporationAdditionalDocumentsResponseError

export const getAddCorporationAdditionalDocumentsUrl = () => {
  return `/users/me/corporation/additional-documents`
}

/**
 * Use this when Paytrie asks for more documents during review. The files are added to those already on file and the enrollment stays `in-review`.
 * @summary Add verification documents to an enrollment that is under review or verified
 */
export const addCorporationAdditionalDocuments = async (
  addCorporationAdditionalDocumentsRequest: AddCorporationAdditionalDocumentsRequest,
  options?: RequestInit
): Promise<addCorporationAdditionalDocumentsResponse> => {
  return customFetch<addCorporationAdditionalDocumentsResponse>(
    getAddCorporationAdditionalDocumentsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(addCorporationAdditionalDocumentsRequest),
    }
  )
}

export type sendPhoneVerificationResponse202 = {
  data: void
  status: 202
}

export type sendPhoneVerificationResponse400 = {
  data: Error
  status: 400
}

export type sendPhoneVerificationResponse403 = {
  data: Error
  status: 403
}

export type sendPhoneVerificationResponse422 = {
  data: Error
  status: 422
}

export type sendPhoneVerificationResponseSuccess =
  sendPhoneVerificationResponse202 & {
    headers: Headers
  }
export type sendPhoneVerificationResponseError = (
  | sendPhoneVerificationResponse400
  | sendPhoneVerificationResponse403
  | sendPhoneVerificationResponse422
) & {
  headers: Headers
}

export type sendPhoneVerificationResponse =
  | sendPhoneVerificationResponseSuccess
  | sendPhoneVerificationResponseError

export const getSendPhoneVerificationUrl = () => {
  return `/users/me/phone/send-verification`
}

/**
 * Records the phone number against the authenticated user and texts them a verification code. The number is exchanged for a verified phone via POST /users/me/phone/verify. A user whose phone is already verified cannot change it here.
 * @summary Send a phone verification code
 */
export const sendPhoneVerification = async (
  sendPhoneVerificationBody: SendPhoneVerificationBody,
  options?: RequestInit
): Promise<sendPhoneVerificationResponse> => {
  return customFetch<sendPhoneVerificationResponse>(
    getSendPhoneVerificationUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sendPhoneVerificationBody),
    }
  )
}

export type verifyPhoneResponse204 = {
  data: void
  status: 204
}

export type verifyPhoneResponse400 = {
  data: Error
  status: 400
}

export type verifyPhoneResponse409 = {
  data: Error
  status: 409
}

export type verifyPhoneResponse422 = {
  data: Error
  status: 422
}

export type verifyPhoneResponseSuccess = verifyPhoneResponse204 & {
  headers: Headers
}
export type verifyPhoneResponseError = (
  | verifyPhoneResponse400
  | verifyPhoneResponse409
  | verifyPhoneResponse422
) & {
  headers: Headers
}

export type verifyPhoneResponse =
  | verifyPhoneResponseSuccess
  | verifyPhoneResponseError

export const getVerifyPhoneUrl = () => {
  return `/users/me/phone/verify`
}

/**
 * Confirms the code sent by POST /users/me/phone/send-verification. Conflicts with 409 when the code was correct but the number is already verified on another account, leaving the caller free to submit a different number.
 * @summary Verify a phone verification code
 */
export const verifyPhone = async (
  verifyPhoneBody: VerifyPhoneBody,
  options?: RequestInit
): Promise<verifyPhoneResponse> => {
  return customFetch<verifyPhoneResponse>(getVerifyPhoneUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyPhoneBody),
  })
}

export type getUsersMeKycUrlResponse200 = {
  data: GetUsersMeKycUrl200
  status: 200
}

export type getUsersMeKycUrlResponse400 = {
  data: Error
  status: 400
}

export type getUsersMeKycUrlResponse401 = {
  data: Error
  status: 401
}

export type getUsersMeKycUrlResponse404 = {
  data: Error
  status: 404
}

export type getUsersMeKycUrlResponse422 = {
  data: Error
  status: 422
}

export type getUsersMeKycUrlResponse502 = {
  data: Error
  status: 502
}

export type getUsersMeKycUrlResponseSuccess = getUsersMeKycUrlResponse200 & {
  headers: Headers
}
export type getUsersMeKycUrlResponseError = (
  | getUsersMeKycUrlResponse400
  | getUsersMeKycUrlResponse401
  | getUsersMeKycUrlResponse404
  | getUsersMeKycUrlResponse422
  | getUsersMeKycUrlResponse502
) & {
  headers: Headers
}

export type getUsersMeKycUrlResponse =
  | getUsersMeKycUrlResponseSuccess
  | getUsersMeKycUrlResponseError

export const getGetUsersMeKycUrlUrl = () => {
  return `/users/me/kyc-url`
}

/**
 * @summary Generate a KYC verification URL for the authenticated user
 */
export const getUsersMeKycUrl = async (
  options?: RequestInit
): Promise<getUsersMeKycUrlResponse> => {
  return customFetch<getUsersMeKycUrlResponse>(getGetUsersMeKycUrlUrl(), {
    ...options,
    method: 'GET',
  })
}

export type getCurrentUserRequirementsResponse200 = {
  data: GetCurrentUserRequirements200
  status: 200
}

export type getCurrentUserRequirementsResponse401 = {
  data: Error
  status: 401
}

export type getCurrentUserRequirementsResponse404 = {
  data: Error
  status: 404
}

export type getCurrentUserRequirementsResponseSuccess =
  getCurrentUserRequirementsResponse200 & {
    headers: Headers
  }
export type getCurrentUserRequirementsResponseError = (
  | getCurrentUserRequirementsResponse401
  | getCurrentUserRequirementsResponse404
) & {
  headers: Headers
}

export type getCurrentUserRequirementsResponse =
  | getCurrentUserRequirementsResponseSuccess
  | getCurrentUserRequirementsResponseError

export const getGetCurrentUserRequirementsUrl = () => {
  return `/users/me/requirements`
}

/**
 * @summary Get the user's onboarding and compliance requirements
 */
export const getCurrentUserRequirements = async (
  options?: RequestInit
): Promise<getCurrentUserRequirementsResponse> => {
  return customFetch<getCurrentUserRequirementsResponse>(
    getGetCurrentUserRequirementsUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type getUserResponse200 = {
  data: GetUser200
  status: 200
}

export type getUserResponse404 = {
  data: Error
  status: 404
}

export type getUserResponseSuccess = getUserResponse200 & {
  headers: Headers
}
export type getUserResponseError = getUserResponse404 & {
  headers: Headers
}

export type getUserResponse = getUserResponseSuccess | getUserResponseError

export const getGetUserUrl = (userId: string) => {
  return `/users/${userId}`
}

/**
 * Confirms the user exists and is reachable by the caller. Returns the user id and onboarding status — personal details are never returned. Read GET /users/{userId}/requirements for what the user still has to complete.
 * @summary Get a user
 */
export const getUser = async (
  userId: string,
  options?: RequestInit
): Promise<getUserResponse> => {
  return customFetch<getUserResponse>(getGetUserUrl(userId), {
    ...options,
    method: 'GET',
  })
}

export type updateUserResponse200 = {
  data: UpdateUser200
  status: 200
}

export type updateUserResponse400 = {
  data: Error
  status: 400
}

export type updateUserResponse401 = {
  data: Error
  status: 401
}

export type updateUserResponse403 = {
  data: Error
  status: 403
}

export type updateUserResponse404 = {
  data: Error
  status: 404
}

export type updateUserResponse409 = {
  data: Error
  status: 409
}

export type updateUserResponse422 = {
  data: Error
  status: 422
}

export type updateUserResponse503 = {
  data: Error
  status: 503
}

export type updateUserResponseSuccess = updateUserResponse200 & {
  headers: Headers
}
export type updateUserResponseError = (
  | updateUserResponse400
  | updateUserResponse401
  | updateUserResponse403
  | updateUserResponse404
  | updateUserResponse409
  | updateUserResponse422
  | updateUserResponse503
) & {
  headers: Headers
}

export type updateUserResponse =
  | updateUserResponseSuccess
  | updateUserResponseError

export const getUpdateUserUrl = (userId: string) => {
  return `/users/${userId}`
}

/**
 * Applies a partial update. Send whatever GET /users/{userId}/requirements reports as outstanding — every field is optional, so requirements can be satisfied one at a time or all at once. Returns the user id and onboarding status; read the requirements endpoint to confirm what the update satisfied.
 * @summary Update a user's onboarding fields
 */
export const updateUser = async (
  userId: string,
  updateUserBody: UpdateUserBody,
  options?: RequestInit
): Promise<updateUserResponse> => {
  return customFetch<updateUserResponse>(getUpdateUserUrl(userId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateUserBody),
  })
}

export type getUserRequirementsResponse200 = {
  data: GetUserRequirements200
  status: 200
}

export type getUserRequirementsResponse401 = {
  data: Error
  status: 401
}

export type getUserRequirementsResponse403 = {
  data: Error
  status: 403
}

export type getUserRequirementsResponse404 = {
  data: Error
  status: 404
}

export type getUserRequirementsResponseSuccess =
  getUserRequirementsResponse200 & {
    headers: Headers
  }
export type getUserRequirementsResponseError = (
  | getUserRequirementsResponse401
  | getUserRequirementsResponse403
  | getUserRequirementsResponse404
) & {
  headers: Headers
}

export type getUserRequirementsResponse =
  | getUserRequirementsResponseSuccess
  | getUserRequirementsResponseError

export const getGetUserRequirementsUrl = (userId: string) => {
  return `/users/${userId}/requirements`
}

/**
 * Reports what the user still has to do before they can transact. Submit the outstanding fields with PATCH /users/{userId}, then read this again — it is the authoritative view of what remains.
 * @summary Get a user's onboarding and compliance requirements
 */
export const getUserRequirements = async (
  userId: string,
  options?: RequestInit
): Promise<getUserRequirementsResponse> => {
  return customFetch<getUserRequirementsResponse>(
    getGetUserRequirementsUrl(userId),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type getUserKycUrlResponse200 = {
  data: GetUserKycUrl200
  status: 200
}

export type getUserKycUrlResponse400 = {
  data: Error
  status: 400
}

export type getUserKycUrlResponseSuccess = getUserKycUrlResponse200 & {
  headers: Headers
}
export type getUserKycUrlResponseError = getUserKycUrlResponse400 & {
  headers: Headers
}

export type getUserKycUrlResponse =
  | getUserKycUrlResponseSuccess
  | getUserKycUrlResponseError

export const getGetUserKycUrlUrl = (userId: string) => {
  return `/users/${userId}/kyc-url`
}

/**
 * @summary Generate a KYC verification URL
 */
export const getUserKycUrl = async (
  userId: string,
  options?: RequestInit
): Promise<getUserKycUrlResponse> => {
  return customFetch<getUserKycUrlResponse>(getGetUserKycUrlUrl(userId), {
    ...options,
    method: 'GET',
  })
}

export type listUserBankAccountsResponse200 = {
  data: ListUserBankAccounts200
  status: 200
}

export type listUserBankAccountsResponseSuccess =
  listUserBankAccountsResponse200 & {
    headers: Headers
  }
export type listUserBankAccountsResponse = listUserBankAccountsResponseSuccess

export const getListUserBankAccountsUrl = (userId: string) => {
  return `/users/${userId}/bank-accounts`
}

/**
 * Returns the user's saved bank accounts as masked metadata (bank name and last 4 digits) for display and selection. Never returns full account numbers. Select an account by passing its `id` as `bankDetailsId` when creating an OTC request.
 * @summary List a user's saved bank accounts
 */
export const listUserBankAccounts = async (
  userId: string,
  options?: RequestInit
): Promise<listUserBankAccountsResponse> => {
  return customFetch<listUserBankAccountsResponse>(
    getListUserBankAccountsUrl(userId),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type importUserKycResponse200 = {
  data: ImportUserKyc200
  status: 200
}

export type importUserKycResponse202 = {
  data: ImportUserKyc202
  status: 202
}

export type importUserKycResponse400 = {
  data: Error
  status: 400
}

export type importUserKycResponse401 = {
  data: Error
  status: 401
}

export type importUserKycResponse409 = {
  data: Error
  status: 409
}

export type importUserKycResponse422 = {
  data: Error
  status: 422
}

export type importUserKycResponseSuccess = (
  | importUserKycResponse200
  | importUserKycResponse202
) & {
  headers: Headers
}
export type importUserKycResponseError = (
  | importUserKycResponse400
  | importUserKycResponse401
  | importUserKycResponse409
  | importUserKycResponse422
) & {
  headers: Headers
}

export type importUserKycResponse =
  | importUserKycResponseSuccess
  | importUserKycResponseError

export const getImportUserKycUrl = (userId: string) => {
  return `/users/${userId}/kyc`
}

/**
 * Import KYC data for a user from a share token. Currently only supports importing using Sumsub Shared KYC. Returns the user id and onboarding status; read GET /users/{userId}/requirements to confirm the KYC requirement is satisfied. When Sumsub has not finished reviewing the shared applicant yet, the import is accepted with 202; the user is verified automatically if Sumsub approves the applicant, or placed in manual review if it does not. Poll GET /users/{userId}/requirements for the outcome.
 * @summary Import KYC data for a user
 */
export const importUserKyc = async (
  userId: string,
  importUserKycBody: ImportUserKycBody,
  options?: RequestInit
): Promise<importUserKycResponse> => {
  return customFetch<importUserKycResponse>(getImportUserKycUrl(userId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importUserKycBody),
  })
}

export type finalizeUserKycDocumentsResponse201 = {
  data: FinalizeUserKycDocuments201
  status: 201
}

export type finalizeUserKycDocumentsResponse404 = {
  data: Error
  status: 404
}

export type finalizeUserKycDocumentsResponseSuccess =
  finalizeUserKycDocumentsResponse201 & {
    headers: Headers
  }
export type finalizeUserKycDocumentsResponseError =
  finalizeUserKycDocumentsResponse404 & {
    headers: Headers
  }

export type finalizeUserKycDocumentsResponse =
  | finalizeUserKycDocumentsResponseSuccess
  | finalizeUserKycDocumentsResponseError

export const getFinalizeUserKycDocumentsUrl = (userId: string) => {
  return `/users/${userId}/kyc-documents`
}

/**
 * @summary Finalize KYC document uploads after direct-to-GCS PUT
 */
export const finalizeUserKycDocuments = async (
  userId: string,
  finalizeUserKycDocumentsBody: FinalizeUserKycDocumentsBody,
  options?: RequestInit
): Promise<finalizeUserKycDocumentsResponse> => {
  return customFetch<finalizeUserKycDocumentsResponse>(
    getFinalizeUserKycDocumentsUrl(userId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(finalizeUserKycDocumentsBody),
    }
  )
}

export type createUserKycDocumentUploadUrlsResponse201 = {
  data: CreateUserKycDocumentUploadUrls201
  status: 201
}

export type createUserKycDocumentUploadUrlsResponse400 = {
  data: Error
  status: 400
}

export type createUserKycDocumentUploadUrlsResponseSuccess =
  createUserKycDocumentUploadUrlsResponse201 & {
    headers: Headers
  }
export type createUserKycDocumentUploadUrlsResponseError =
  createUserKycDocumentUploadUrlsResponse400 & {
    headers: Headers
  }

export type createUserKycDocumentUploadUrlsResponse =
  | createUserKycDocumentUploadUrlsResponseSuccess
  | createUserKycDocumentUploadUrlsResponseError

export const getCreateUserKycDocumentUploadUrlsUrl = (userId: string) => {
  return `/users/${userId}/kyc-documents/upload-urls`
}

/**
 * @summary Request signed URLs for direct-to-GCS KYC document upload
 */
export const createUserKycDocumentUploadUrls = async (
  userId: string,
  createUserKycDocumentUploadUrlsBody: CreateUserKycDocumentUploadUrlsBody,
  options?: RequestInit
): Promise<createUserKycDocumentUploadUrlsResponse> => {
  return customFetch<createUserKycDocumentUploadUrlsResponse>(
    getCreateUserKycDocumentUploadUrlsUrl(userId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createUserKycDocumentUploadUrlsBody),
    }
  )
}

export type listUserOtcRequestsResponse200 = {
  data: ListUserOtcRequests200
  status: 200
}

export type listUserOtcRequestsResponse401 = {
  data: Error
  status: 401
}

export type listUserOtcRequestsResponse403 = {
  data: Error
  status: 403
}

export type listUserOtcRequestsResponse404 = {
  data: Error
  status: 404
}

export type listUserOtcRequestsResponseSuccess =
  listUserOtcRequestsResponse200 & {
    headers: Headers
  }
export type listUserOtcRequestsResponseError = (
  | listUserOtcRequestsResponse401
  | listUserOtcRequestsResponse403
  | listUserOtcRequestsResponse404
) & {
  headers: Headers
}

export type listUserOtcRequestsResponse =
  | listUserOtcRequestsResponseSuccess
  | listUserOtcRequestsResponseError

export const getListUserOtcRequestsUrl = (
  userId: string,
  params?: ListUserOtcRequestsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/users/${userId}/otc-requests?${stringifiedParams}`
    : `/users/${userId}/otc-requests`
}

/**
 * @summary List OTC requests for a specific user
 */
export const listUserOtcRequests = async (
  userId: string,
  params?: ListUserOtcRequestsParams,
  options?: RequestInit
): Promise<listUserOtcRequestsResponse> => {
  return customFetch<listUserOtcRequestsResponse>(
    getListUserOtcRequestsUrl(userId, params),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type createUserOtcRequestResponse201 = {
  data: CreateUserOtcRequest201
  status: 201
}

export type createUserOtcRequestResponse400 = {
  data: Error
  status: 400
}

export type createUserOtcRequestResponse401 = {
  data: Error
  status: 401
}

export type createUserOtcRequestResponse403 = {
  data: Error
  status: 403
}

export type createUserOtcRequestResponse404 = {
  data: Error
  status: 404
}

export type createUserOtcRequestResponse429 = {
  data: Error
  status: 429
}

export type createUserOtcRequestResponse503 = {
  data: Error
  status: 503
}

export type createUserOtcRequestResponseSuccess =
  createUserOtcRequestResponse201 & {
    headers: Headers
  }
export type createUserOtcRequestResponseError = (
  | createUserOtcRequestResponse400
  | createUserOtcRequestResponse401
  | createUserOtcRequestResponse403
  | createUserOtcRequestResponse404
  | createUserOtcRequestResponse429
  | createUserOtcRequestResponse503
) & {
  headers: Headers
}

export type createUserOtcRequestResponse =
  | createUserOtcRequestResponseSuccess
  | createUserOtcRequestResponseError

export const getCreateUserOtcRequestUrl = (userId: string) => {
  return `/users/${userId}/otc-requests`
}

/**
 * @summary Create an OTC request for a specific user
 */
export const createUserOtcRequest = async (
  userId: string,
  createOtcRequest: CreateOtcRequest,
  options?: RequestInit
): Promise<createUserOtcRequestResponse> => {
  return customFetch<createUserOtcRequestResponse>(
    getCreateUserOtcRequestUrl(userId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createOtcRequest),
    }
  )
}

export type listUserTransactionsResponse200 = {
  data: ListUserTransactions200
  status: 200
}

export type listUserTransactionsResponse401 = {
  data: Error
  status: 401
}

export type listUserTransactionsResponse403 = {
  data: Error
  status: 403
}

export type listUserTransactionsResponseSuccess =
  listUserTransactionsResponse200 & {
    headers: Headers
  }
export type listUserTransactionsResponseError = (
  | listUserTransactionsResponse401
  | listUserTransactionsResponse403
) & {
  headers: Headers
}

export type listUserTransactionsResponse =
  | listUserTransactionsResponseSuccess
  | listUserTransactionsResponseError

export const getListUserTransactionsUrl = (
  userId: string,
  params?: ListUserTransactionsParams
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/users/${userId}/transactions?${stringifiedParams}`
    : `/users/${userId}/transactions`
}

/**
 * @summary List transactions for a specific user
 */
export const listUserTransactions = async (
  userId: string,
  params?: ListUserTransactionsParams,
  options?: RequestInit
): Promise<listUserTransactionsResponse> => {
  return customFetch<listUserTransactionsResponse>(
    getListUserTransactionsUrl(userId, params),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type createUserTransactionResponse201 = {
  data: CreateUserTransaction201
  status: 201
}

export type createUserTransactionResponse400 = {
  data: Error
  status: 400
}

export type createUserTransactionResponse401 = {
  data: Error
  status: 401
}

export type createUserTransactionResponse403 = {
  data: Error
  status: 403
}

export type createUserTransactionResponse422 = {
  data: Error
  status: 422
}

export type createUserTransactionResponse500 = {
  data: Error
  status: 500
}

export type createUserTransactionResponse503 = {
  data: Error
  status: 503
}

export type createUserTransactionResponseSuccess =
  createUserTransactionResponse201 & {
    headers: Headers
  }
export type createUserTransactionResponseError = (
  | createUserTransactionResponse400
  | createUserTransactionResponse401
  | createUserTransactionResponse403
  | createUserTransactionResponse422
  | createUserTransactionResponse500
  | createUserTransactionResponse503
) & {
  headers: Headers
}

export type createUserTransactionResponse =
  | createUserTransactionResponseSuccess
  | createUserTransactionResponseError

export const getCreateUserTransactionUrl = (userId: string) => {
  return `/users/${userId}/transactions`
}

/**
 * @summary Create a transaction for a specific user
 */
export const createUserTransaction = async (
  userId: string,
  createTransactionRequest: CreateTransactionRequest,
  options?: RequestInit
): Promise<createUserTransactionResponse> => {
  return customFetch<createUserTransactionResponse>(
    getCreateUserTransactionUrl(userId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(createTransactionRequest),
    }
  )
}

export type cancelUserTransactionResponse200 = {
  data: CancelUserTransaction200
  status: 200
}

export type cancelUserTransactionResponse401 = {
  data: Error
  status: 401
}

export type cancelUserTransactionResponse403 = {
  data: Error
  status: 403
}

export type cancelUserTransactionResponse404 = {
  data: Error
  status: 404
}

export type cancelUserTransactionResponse409 = {
  data: Error
  status: 409
}

export type cancelUserTransactionResponseSuccess =
  cancelUserTransactionResponse200 & {
    headers: Headers
  }
export type cancelUserTransactionResponseError = (
  | cancelUserTransactionResponse401
  | cancelUserTransactionResponse403
  | cancelUserTransactionResponse404
  | cancelUserTransactionResponse409
) & {
  headers: Headers
}

export type cancelUserTransactionResponse =
  | cancelUserTransactionResponseSuccess
  | cancelUserTransactionResponseError

export const getCancelUserTransactionUrl = (userId: string, txId: string) => {
  return `/users/${userId}/transactions/${txId}/cancel`
}

/**
 * @summary Cancel a transaction for a specific user
 */
export const cancelUserTransaction = async (
  userId: string,
  txId: string,
  options?: RequestInit
): Promise<cancelUserTransactionResponse> => {
  return customFetch<cancelUserTransactionResponse>(
    getCancelUserTransactionUrl(userId, txId),
    {
      ...options,
      method: 'PUT',
    }
  )
}

export type getWebhookConfigurationResponse200 = {
  data: GetWebhookConfiguration200
  status: 200
}

export type getWebhookConfigurationResponse404 = {
  data: Error
  status: 404
}

export type getWebhookConfigurationResponseSuccess =
  getWebhookConfigurationResponse200 & {
    headers: Headers
  }
export type getWebhookConfigurationResponseError =
  getWebhookConfigurationResponse404 & {
    headers: Headers
  }

export type getWebhookConfigurationResponse =
  | getWebhookConfigurationResponseSuccess
  | getWebhookConfigurationResponseError

export const getGetWebhookConfigurationUrl = () => {
  return `/webhook-configurations`
}

/**
 * Returns the URL Paytrie delivers v2 webhook envelopes to for this integrator. Returns 404 if no configuration exists.
 * @summary Get the current webhook configuration
 */
export const getWebhookConfiguration = async (
  options?: RequestInit
): Promise<getWebhookConfigurationResponse> => {
  return customFetch<getWebhookConfigurationResponse>(
    getGetWebhookConfigurationUrl(),
    {
      ...options,
      method: 'GET',
    }
  )
}

export type setWebhookConfigurationResponse200 = {
  data: SetWebhookConfiguration200
  status: 200
}

export type setWebhookConfigurationResponse403 = {
  data: Error
  status: 403
}

export type setWebhookConfigurationResponse422 = {
  data: Error
  status: 422
}

export type setWebhookConfigurationResponseSuccess =
  setWebhookConfigurationResponse200 & {
    headers: Headers
  }
export type setWebhookConfigurationResponseError = (
  | setWebhookConfigurationResponse403
  | setWebhookConfigurationResponse422
) & {
  headers: Headers
}

export type setWebhookConfigurationResponse =
  | setWebhookConfigurationResponseSuccess
  | setWebhookConfigurationResponseError

export const getSetWebhookConfigurationUrl = () => {
  return `/webhook-configurations`
}

/**
 * Sets the URL Paytrie will deliver all v2 webhook envelopes to. Full replacement — any prior URL is overwritten.
 *
 * On the very first PUT for an integrator that does not yet have a signing secret, a new secret is generated atomically and included in the response as `signingSecret`. Save it immediately — it will not be returned again. On subsequent PUTs the field is omitted. To rotate later, use `POST /v2/webhook-configurations/signing-secret/rotate`.
 * @summary Create or replace the webhook configuration
 */
export const setWebhookConfiguration = async (
  setWebhookConfigurationBody: SetWebhookConfigurationBody,
  options?: RequestInit
): Promise<setWebhookConfigurationResponse> => {
  return customFetch<setWebhookConfigurationResponse>(
    getSetWebhookConfigurationUrl(),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(setWebhookConfigurationBody),
    }
  )
}

export type deleteWebhookConfigurationResponse204 = {
  data: void
  status: 204
}

export type deleteWebhookConfigurationResponse403 = {
  data: Error
  status: 403
}

export type deleteWebhookConfigurationResponse404 = {
  data: Error
  status: 404
}

export type deleteWebhookConfigurationResponseSuccess =
  deleteWebhookConfigurationResponse204 & {
    headers: Headers
  }
export type deleteWebhookConfigurationResponseError = (
  | deleteWebhookConfigurationResponse403
  | deleteWebhookConfigurationResponse404
) & {
  headers: Headers
}

export type deleteWebhookConfigurationResponse =
  | deleteWebhookConfigurationResponseSuccess
  | deleteWebhookConfigurationResponseError

export const getDeleteWebhookConfigurationUrl = () => {
  return `/webhook-configurations`
}

/**
 * Removes the webhook configuration entirely. No v2 webhook envelopes will be delivered until the configuration is recreated.
 * @summary Remove the webhook configuration
 */
export const deleteWebhookConfiguration = async (
  options?: RequestInit
): Promise<deleteWebhookConfigurationResponse> => {
  return customFetch<deleteWebhookConfigurationResponse>(
    getDeleteWebhookConfigurationUrl(),
    {
      ...options,
      method: 'DELETE',
    }
  )
}

export type sendTestWebhookResponse200 = {
  data: SendTestWebhook200
  status: 200
}

export type sendTestWebhookResponse404 = {
  data: Error
  status: 404
}

export type sendTestWebhookResponse502 = {
  data: Error
  status: 502
}

export type sendTestWebhookResponseSuccess = sendTestWebhookResponse200 & {
  headers: Headers
}
export type sendTestWebhookResponseError = (
  | sendTestWebhookResponse404
  | sendTestWebhookResponse502
) & {
  headers: Headers
}

export type sendTestWebhookResponse =
  | sendTestWebhookResponseSuccess
  | sendTestWebhookResponseError

export const getSendTestWebhookUrl = () => {
  return `/webhook-configurations/test`
}

/**
 * Delivers a synthetic user.update envelope to the configured webhook URL. Useful for verifying that your endpoint is reachable and that signature verification is set up correctly.
 * @summary Send a synthetic test webhook
 */
export const sendTestWebhook = async (
  options?: RequestInit
): Promise<sendTestWebhookResponse> => {
  return customFetch<sendTestWebhookResponse>(getSendTestWebhookUrl(), {
    ...options,
    method: 'POST',
  })
}

export type rotateWebhookSigningSecretResponse200 = {
  data: RotateWebhookSigningSecret200
  status: 200
}

export type rotateWebhookSigningSecretResponse403 = {
  data: Error
  status: 403
}

export type rotateWebhookSigningSecretResponse404 = {
  data: Error
  status: 404
}

export type rotateWebhookSigningSecretResponse500 = {
  data: Error
  status: 500
}

export type rotateWebhookSigningSecretResponseSuccess =
  rotateWebhookSigningSecretResponse200 & {
    headers: Headers
  }
export type rotateWebhookSigningSecretResponseError = (
  | rotateWebhookSigningSecretResponse403
  | rotateWebhookSigningSecretResponse404
  | rotateWebhookSigningSecretResponse500
) & {
  headers: Headers
}

export type rotateWebhookSigningSecretResponse =
  | rotateWebhookSigningSecretResponseSuccess
  | rotateWebhookSigningSecretResponseError

export const getRotateWebhookSigningSecretUrl = () => {
  return `/webhook-configurations/signing-secret/rotate`
}

/**
 * Generates a new HMAC-SHA256 signing secret used to sign webhook payloads. The previous secret is invalidated immediately. Update your verification logic before rotating.
 *
 * **Note:** The signing secret is shared between v1 and v2 webhook delivery. Rotating here invalidates the secret used by both `/webhooks` (legacy) and `/v2/webhook-configurations` paths. If you have a v2 subscription configured and later delete it to roll back to v1, the rotated secret remains the active one — re-rotate via the v1 `POST /webhook-signing-secret` endpoint only if you need a fresh key.
 * @summary Rotate the webhook signing secret
 */
export const rotateWebhookSigningSecret = async (
  options?: RequestInit
): Promise<rotateWebhookSigningSecretResponse> => {
  return customFetch<rotateWebhookSigningSecretResponse>(
    getRotateWebhookSigningSecretUrl(),
    {
      ...options,
      method: 'POST',
    }
  )
}

export type receiveCircleWebhookResponse204 = {
  data: void
  status: 204
}

export type receiveCircleWebhookResponse400 = {
  data: Error
  status: 400
}

export type receiveCircleWebhookResponse401 = {
  data: Error
  status: 401
}

export type receiveCircleWebhookResponse403 = {
  data: Error
  status: 403
}

export type receiveCircleWebhookResponseSuccess =
  receiveCircleWebhookResponse204 & {
    headers: Headers
  }
export type receiveCircleWebhookResponseError = (
  | receiveCircleWebhookResponse400
  | receiveCircleWebhookResponse401
  | receiveCircleWebhookResponse403
) & {
  headers: Headers
}

export type receiveCircleWebhookResponse =
  | receiveCircleWebhookResponseSuccess
  | receiveCircleWebhookResponseError

export const getReceiveCircleWebhookUrl = () => {
  return `/webhooks/circle`
}

/**
 * Subscriber endpoint for Circle Mint notifications, which are delivered as Amazon SNS messages. Authentication is by SNS signature verification against the pinned Circle topic rather than by API key, so the endpoint is unauthenticated in the usual sense. Circle also probes the same path with HEAD before delivering to it.
 * @summary Receive a Circle Mint notification
 */
export const receiveCircleWebhook = async (
  options?: RequestInit
): Promise<receiveCircleWebhookResponse> => {
  return customFetch<receiveCircleWebhookResponse>(
    getReceiveCircleWebhookUrl(),
    {
      ...options,
      method: 'POST',
    }
  )
}

export type pingCircleWebhookResponse204 = {
  data: void
  status: 204
}

export type pingCircleWebhookResponseSuccess = pingCircleWebhookResponse204 & {
  headers: Headers
}
export type pingCircleWebhookResponse = pingCircleWebhookResponseSuccess

export const getPingCircleWebhookUrl = () => {
  return `/webhooks/circle`
}

/**
 * @summary Confirm the Circle Mint subscriber endpoint is reachable
 */
export const pingCircleWebhook = async (
  options?: RequestInit
): Promise<pingCircleWebhookResponse> => {
  return customFetch<pingCircleWebhookResponse>(getPingCircleWebhookUrl(), {
    ...options,
    method: 'GET',
  })
}
